/* eslint-disable */
// Generated by trade-optimizer-extension (npm run build:lib). Do not edit by hand.
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { computeBPProjections, BP_BASE } from "../bpProjections";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
const DEFAULT_CONFIG = {
  shapes: [
    { send: 1, receive: 1 },
    { send: 2, receive: 1 },
    { send: 1, receive: 2 },
    { send: 2, receive: 2 },
    { send: 3, receive: 2 }
  ],
  maxOutgoingCandidates: 12,
  maxIncomingCandidates: 12,
  maxTripleCandidates: 8,
  minQbTradeValue: 15,
  maxPartners: 20,
  enforceValueTolerance: true,
  maxTradeValueDifferencePercent: 15,
  tradeValueAbsoluteSlack: 4,
  minUserGain: 0.5,
  clearOpponentGain: 0.25,
  maxOpponentLoss: 1,
  opponentValueGainThreshold: 5,
  opponentValueGainPercent: 10,
  maxOpponentLossForSecondaryReasons: 0.5,
  holeMarginPoints: 1.5,
  expendableMarginalValue: 1,
  rankingMode: "winWin",
  winWinMinOpponentGain: 0.5,
  weaknessSolveMinGain: 1,
  weaknessSolveTopN: 3,
  weights: { weaknessCap: 0.3, opponentWeaknessCap: 0.15, mutualCap: 0.3, fairnessCap: 0.15, depthCap: 0.05 },
  mutualScalePoints: 4,
  weaknessScalePoints: 8,
  depthScalePoints: 6,
  topN: 10,
  maxPages: 10,
  unfairMinOutgoingValue: 30,
  unfairValuePointsPerProjectionPoint: 10,
  unfairTopN: 10,
  unfairMinValueGapPercent: 10,
  unfairMaxValueGainPercent: 75,
  unfairMaxOpponentLoss: 6,
  unfairRequireOpponentAngle: true,
  maxTradesPerPartner: 3,
  unlistedTradeValue: "estimate",
  baselineWaiverMoves: 2,
  minWaiverMoveGain: 1
};
function mergeConfig(overrides) {
  if (!overrides) return DEFAULT_CONFIG;
  return {
    ...DEFAULT_CONFIG,
    ...overrides,
    weights: { ...DEFAULT_CONFIG.weights, ...overrides.weights ?? {} }
  };
}
function secondaryBand(config) {
  const w = config.weights;
  return w.weaknessCap + w.opponentWeaknessCap + w.mutualCap + w.fairnessCap + w.depthCap;
}
const ALL_POSITIONS = ["QB", "RB", "WR", "TE", "K", "DST"];
const OFFENSE_POSITIONS = ["QB", "RB", "WR", "TE"];
function normalizePosition(raw) {
  if (!raw) return null;
  const p = raw.toUpperCase().replace(/[^A-Z]/g, "");
  switch (p) {
    case "QB":
      return "QB";
    case "RB":
    case "HB":
    case "FB":
      return "RB";
    case "WR":
      return "WR";
    case "TE":
      return "TE";
    case "K":
    case "PK":
      return "K";
    case "DST":
    case "DEF":
    case "D":
    case "DS":
      return "DST";
    default:
      return null;
  }
}
const SLOT_PRESETS = {
  QB: { id: "QB", label: "QB", eligible: ["QB"] },
  RB: { id: "RB", label: "RB", eligible: ["RB"] },
  WR: { id: "WR", label: "WR", eligible: ["WR"] },
  TE: { id: "TE", label: "TE", eligible: ["TE"] },
  FLEX: { id: "FLEX", label: "FLEX", eligible: ["RB", "WR", "TE"] },
  SUPERFLEX: { id: "SUPERFLEX", label: "SFLEX", eligible: ["QB", "RB", "WR", "TE"] },
  "RB/WR": { id: "RB/WR", label: "RB/WR", eligible: ["RB", "WR"] },
  "WR/TE": { id: "WR/TE", label: "WR/TE", eligible: ["WR", "TE"] },
  K: { id: "K", label: "K", eligible: ["K"] },
  DST: { id: "DST", label: "D/ST", eligible: ["DST"] }
};
function slot(id, count = 1) {
  return { ...SLOT_PRESETS[id], count };
}
function standardLineup() {
  return [
    slot("QB"),
    slot("RB", 2),
    slot("WR", 2),
    slot("TE"),
    slot("FLEX"),
    slot("K"),
    slot("DST")
  ];
}
function expandSlots(slots) {
  const out = [];
  for (const s of slots) {
    for (let i = 1; i <= s.count; i++) {
      out.push({
        slotId: s.id,
        label: s.label,
        index: i,
        key: s.count > 1 ? `${s.label}${i}` : s.label,
        eligible: s.eligible
      });
    }
  }
  return out;
}
function dedicatedSlotCount(slots, position) {
  return slots.filter((s) => s.eligible.length === 1 && s.eligible[0] === position).reduce((n, s) => n + s.count, 0);
}
function sharedSlotDemand(slots, position) {
  return slots.filter((s) => s.eligible.length > 1 && s.eligible.includes(position)).reduce((n, s) => n + s.count / s.eligible.length, 0);
}
const planCache = /* @__PURE__ */ new WeakMap();
function isLaminar(instances) {
  const sets = instances.map((i) => new Set(i.eligible));
  for (let a = 0; a < sets.length; a++) {
    for (let b = a + 1; b < sets.length; b++) {
      const A = sets[a];
      const B = sets[b];
      let inter = 0;
      for (const p of A) if (B.has(p)) inter++;
      if (inter === 0) continue;
      const nested = inter === A.size || inter === B.size;
      if (!nested) return false;
    }
  }
  return true;
}
function planFor(slots) {
  let plan = planCache.get(slots);
  if (plan) return plan;
  const instances = expandSlots(slots);
  const greedyOrder = instances.map((inst, i) => i).sort((a, b) => instances[a].eligible.length - instances[b].eligible.length || a - b);
  plan = { instances, greedyOrder, laminar: isLaminar(instances) };
  planCache.set(slots, plan);
  return plan;
}
function projectionOf(p) {
  return p.projection > 0 ? p.projection : 0;
}
function greedy(players, plan) {
  const sorted = players.map((p, i) => ({ p, i, v: projectionOf(p) })).sort((a, b) => b.v - a.v || a.i - b.i);
  const used = new Array(sorted.length).fill(false);
  const chosen = new Array(plan.instances.length).fill(null);
  for (const idx of plan.greedyOrder) {
    const eligible = plan.instances[idx].eligible;
    for (let k = 0; k < sorted.length; k++) {
      if (used[k]) continue;
      if (eligible.includes(sorted[k].p.position)) {
        used[k] = true;
        chosen[idx] = sorted[k].p;
        break;
      }
    }
  }
  return chosen;
}
function hungarian(players, plan) {
  const n = plan.instances.length;
  const m = Math.max(n, players.length);
  const cost = [];
  for (let r = 0; r < n; r++) {
    const row = new Array(m);
    const eligible = plan.instances[r].eligible;
    for (let c = 0; c < m; c++) {
      if (c >= players.length) row[c] = 0;
      else if (eligible.includes(players[c].position)) row[c] = -projectionOf(players[c]);
      else row[c] = 1e9;
    }
    cost.push(row);
  }
  const u = new Array(n + 1).fill(0);
  const v = new Array(m + 1).fill(0);
  const p = new Array(m + 1).fill(0);
  const way = new Array(m + 1).fill(0);
  for (let i = 1; i <= n; i++) {
    p[0] = i;
    let j0 = 0;
    const minv = new Array(m + 1).fill(Infinity);
    const used = new Array(m + 1).fill(false);
    do {
      used[j0] = true;
      const i0 = p[j0];
      let delta = Infinity;
      let j1 = 0;
      for (let j = 1; j <= m; j++) {
        if (used[j]) continue;
        const cur = cost[i0 - 1][j - 1] - u[i0] - v[j];
        if (cur < minv[j]) {
          minv[j] = cur;
          way[j] = j0;
        }
        if (minv[j] < delta) {
          delta = minv[j];
          j1 = j;
        }
      }
      for (let j = 0; j <= m; j++) {
        if (used[j]) {
          u[p[j]] += delta;
          v[j] -= delta;
        } else {
          minv[j] -= delta;
        }
      }
      j0 = j1;
    } while (p[j0] !== 0);
    do {
      const j1 = way[j0];
      p[j0] = p[j1];
      j0 = j1;
    } while (j0 !== 0);
  }
  const chosen = new Array(n).fill(null);
  for (let j = 1; j <= m; j++) {
    const r = p[j];
    if (r === 0) continue;
    const c = j - 1;
    if (c < players.length && cost[r - 1][c] !== 1e9) chosen[r - 1] = players[c];
  }
  return chosen;
}
function optimizeLineup(players, slots) {
  const plan = planFor(slots);
  const chosen = plan.laminar ? greedy(players, plan) : hungarian(players, plan);
  const starterIds = /* @__PURE__ */ new Set();
  const assignments = plan.instances.map((slot2, i) => {
    const player = chosen[i];
    if (player) starterIds.add(player.id);
    return { slot: slot2, player, projection: player ? projectionOf(player) : 0 };
  });
  const total = assignments.reduce((n, a) => n + a.projection, 0);
  return {
    total,
    assignments,
    starters: assignments.map((a) => a.player).filter((p) => p !== null),
    bench: players.filter((p) => !starterIds.has(p.id))
  };
}
function optimalTotal(players, slots) {
  const plan = planFor(slots);
  const chosen = plan.laminar ? greedy(players, plan) : hungarian(players, plan);
  let total = 0;
  for (const p of chosen) if (p) total += projectionOf(p);
  return total;
}
function solverFor(slots) {
  return planFor(slots).laminar ? "greedy" : "hungarian";
}
function bruteForceOptimalTotal(players, slots) {
  const instances = expandSlots(slots);
  const used = new Array(players.length).fill(false);
  let best = 0;
  const rec = (i, acc) => {
    if (i === instances.length) {
      if (acc > best) best = acc;
      return;
    }
    rec(i + 1, acc);
    for (let k = 0; k < players.length; k++) {
      if (used[k] || !instances[i].eligible.includes(players[k].position)) continue;
      used[k] = true;
      rec(i + 1, acc + projectionOf(players[k]));
      used[k] = false;
    }
  };
  rec(0, 0);
  return best;
}
function marginalLineupValue(player, roster, slots, baseTotal) {
  const base = baseTotal ?? optimalTotal(roster, slots);
  const without = roster.filter((p) => p.id !== player.id);
  return Math.max(0, base - optimalTotal(without, slots));
}
function computeMarginalValues(roster, slots) {
  const base = optimalTotal(roster, slots);
  const out = {};
  for (const p of roster) {
    if (p.projection <= 0) {
      out[p.id] = 0;
      continue;
    }
    out[p.id] = marginalLineupValue(p, roster, slots, base);
  }
  return out;
}
function lineupEntryGain(player, roster, slots, baseTotal) {
  const base = baseTotal ?? optimalTotal(roster, slots);
  return Math.max(0, optimalTotal([...roster, player], slots) - base);
}
function computeReplacementLevels(league) {
  const levels = {};
  const source = {};
  const { teamCount, lineupSlots } = league.settings;
  for (const pos of ALL_POSITIONS) {
    const available = league.availablePlayers.filter((p) => p.position === pos && p.projection > 0);
    if (available.length > 0) {
      levels[pos] = Math.max(...available.map((p) => p.projection));
      source[pos] = "waivers";
      continue;
    }
    if (!OFFENSE_POSITIONS.includes(pos)) {
      levels[pos] = 0;
      source[pos] = "none";
      continue;
    }
    const rostered = league.teams.flatMap((t) => t.players).filter((p) => p.position === pos).map((p) => p.projection).sort((a, b) => b - a);
    const demand = dedicatedSlotCount(lineupSlots, pos) + sharedSlotDemand(lineupSlots, pos);
    const rank = Math.ceil(teamCount * (demand + 1));
    const value = rostered.length === 0 ? 0 : rostered[Math.min(rank, rostered.length) - 1] ?? 0;
    levels[pos] = Math.max(0, value);
    source[pos] = rostered.length ? "estimated" : "none";
  }
  return { levels, source };
}
function replacementForSlot(levels, eligible) {
  return Math.max(0, ...eligible.map((p) => levels[p] ?? 0));
}
function median(values) {
  if (!values.length) return 0;
  const s = [...values].sort((a, b) => a - b);
  const mid = Math.floor(s.length / 2);
  return s.length % 2 ? s[mid] : (s[mid - 1] + s[mid]) / 2;
}
function computeSlotBenchmarks(lineups) {
  const byKey = /* @__PURE__ */ new Map();
  for (const lineup of lineups) {
    const grouped = /* @__PURE__ */ new Map();
    for (const a of lineup.assignments) {
      const list = grouped.get(a.slot.slotId) ?? [];
      list.push(a.projection);
      grouped.set(a.slot.slotId, list);
    }
    for (const a of lineup.assignments) {
      const list = grouped.get(a.slot.slotId).sort((x, y) => y - x);
      const value = list[a.slot.index - 1] ?? 0;
      const arr = byKey.get(a.slot.key) ?? [];
      arr.push(value);
      byKey.set(a.slot.key, arr);
    }
  }
  const out = /* @__PURE__ */ new Map();
  for (const [key, values] of byKey) {
    const sorted = [...values].sort((a, b) => b - a);
    out.set(key, { key, values: sorted, median: median(sorted) });
  }
  return out;
}
function analyzeWeaknesses(lineup, ctx) {
  const grouped = /* @__PURE__ */ new Map();
  for (const a of lineup.assignments) {
    const list = grouped.get(a.slot.slotId) ?? [];
    list.push(a);
    grouped.set(a.slot.slotId, list);
  }
  const ordered = [...grouped.values()].flatMap(
    (list) => [...list].sort((x, y) => y.projection - x.projection).map((a, i) => ({ ...a, slot: { ...a.slot, index: i + 1, key: list.length > 1 ? `${a.slot.label}${i + 1}` : a.slot.label } }))
  );
  const results = ordered.map((a) => {
    const eligible = a.slot.eligible;
    const replacement = replacementForSlot(ctx.replacement, eligible);
    const surplus = a.projection - replacement;
    const isHole = a.player === null || surplus <= ctx.config.holeMarginPoints;
    const bench = ctx.benchmarks.get(a.slot.key);
    const leagueMedian = (bench == null ? void 0 : bench.median) ?? 0;
    const rank = bench ? bench.values.filter((v) => v > a.projection + 1e-9).length + 1 : 1;
    const targets = [];
    for (const other of ctx.otherTeams) {
      for (const p of other.players) {
        if (!eligible.includes(p.position)) continue;
        if (p.projection <= a.projection) continue;
        if ((other.marginal[p.id] ?? 0) > ctx.config.expendableMarginalValue + 2) continue;
        targets.push({ player: p, teamId: other.teamId, gain: p.projection - a.projection });
      }
    }
    targets.sort((x, y) => y.gain - x.gain);
    const top = targets.slice(0, Math.max(1, ctx.teamCount));
    const high = top.length ? top[0].gain : 0;
    const low = top.length ? top[Math.min(top.length - 1, Math.floor(top.length / 2))].gain : 0;
    const severity = high + (isHole ? Math.max(0, replacement - a.projection + ctx.config.holeMarginPoints) : 0);
    return {
      slot: a.slot,
      key: a.slot.key,
      eligible,
      starter: a.player,
      projection: a.projection,
      replacementProjection: replacement,
      surplusOverReplacement: surplus,
      isHole,
      leagueMedian,
      leagueRank: rank,
      pointsBelowMedian: Math.max(0, leagueMedian - a.projection),
      upgradeRange: { low: Math.max(0, low), high: Math.max(0, high) },
      severity,
      upgradeTargets: top
    };
  });
  return results.sort((x, y) => y.severity - x.severity || x.projection - y.projection);
}
function positionalNeed(weaknesses) {
  const need = { QB: 0, RB: 0, WR: 0, TE: 0, K: 0, DST: 0 };
  for (const w of weaknesses) {
    const share = w.severity / w.eligible.length;
    for (const pos of w.eligible) need[pos] += share;
  }
  return need;
}
function surplusLevel(trapped) {
  if (trapped <= 0.5) return "very low";
  if (trapped < 2.5) return "low";
  if (trapped < 5) return "medium";
  if (trapped < 9) return "high";
  return "very high";
}
function analyzeSurplus(roster, lineup, marginal, replacement, config) {
  const starterIds = new Set(lineup.starters.map((p) => p.id));
  return ALL_POSITIONS.map((position) => {
    var _a;
    const atPos = roster.filter((p) => p.position === position);
    const starters = atPos.filter((p) => starterIds.has(p.id)).sort((a, b) => b.projection - a.projection);
    const bench = atPos.filter((p) => !starterIds.has(p.id)).sort((a, b) => b.projection - a.projection);
    const repl = replacement[position] ?? 0;
    const trappedProjection = bench.reduce((n, p) => n + Math.max(0, p.projection - repl), 0);
    const expendable = atPos.map((p) => ({ player: p, marginal: marginal[p.id] ?? 0 })).filter((e) => e.marginal <= config.expendableMarginalValue && e.player.projection > 0).sort((a, b) => b.player.tradeValue - a.player.tradeValue || b.player.projection - a.player.projection);
    const trappedTradeValue = expendable.reduce((n, e) => n + e.player.tradeValue, 0);
    return {
      position,
      starters,
      bench,
      trappedProjection,
      trappedTradeValue,
      bestBenchProjection: ((_a = bench[0]) == null ? void 0 : _a.projection) ?? 0,
      expendable,
      level: surplusLevel(trappedProjection),
      score: trappedProjection
    };
  });
}
function totalTradeValue(players) {
  return players.reduce((n, p) => n + p.tradeValue, 0);
}
function withPlayers(roster, remove, add) {
  const removeIds = new Set(remove.map((p) => p.id));
  return [...roster.filter((p) => !removeIds.has(p.id)), ...add];
}
function dropCandidates(roster, starterIds) {
  return roster.filter((p) => !starterIds.has(p.id) && OFFENSE_POSITIONS.includes(p.position) && p.projectionSource === "dataset").sort((a, b) => a.projection - b.projection || a.tradeValue - b.tradeValue);
}
function applyFreeWaiverMoves(league, maxMovesPerTeam, dropMargin = 1.5, minSwapGain = 1) {
  const moves = {};
  if (maxMovesPerTeam <= 0) return { league, moves };
  const slots = league.settings.lineupSlots;
  const pool2 = [...league.availablePlayers].filter((p) => p.projection > 0).sort((a, b) => b.projection - a.projection);
  const claimed = /* @__PURE__ */ new Set();
  const replacement = { QB: 0, RB: 0, WR: 0, TE: 0, K: 0, DST: 0 };
  for (const p of pool2) replacement[p.position] = Math.max(replacement[p.position], p.projection);
  const asRostered = (fa) => ({ ...fa, tradeValue: 0, tradeValueSource: "none" });
  const bestAdd = (roster) => {
    const base = optimalTotal(roster, slots);
    let best = null;
    const seen = /* @__PURE__ */ new Set();
    for (const fa of pool2) {
      if (claimed.has(fa.id) || seen.has(fa.position)) continue;
      seen.add(fa.position);
      const gain = optimalTotal([...roster, fa], slots) - base;
      if (!best || gain > best.gain + 1e-9 || Math.abs(gain - best.gain) < 1e-9 && fa.projection > best.player.projection) best = { player: fa, gain };
    }
    return best;
  };
  const teams = league.teams.map((team) => {
    let roster = [...team.players];
    const teamMoves = [];
    while (roster.length < league.settings.rosterSize) {
      const best = bestAdd(roster);
      if (!best) break;
      claimed.add(best.player.id);
      roster.push(asRostered(best.player));
      teamMoves.push({ add: best.player, drop: null, gain: best.gain });
    }
    for (let i = 0; i < maxMovesPerTeam; i++) {
      const lineup = optimizeLineup(roster, slots);
      const starterIds = new Set(lineup.starters.map((p) => p.id));
      const drops = dropCandidates(roster, starterIds).filter((p) => p.projection <= replacement[p.position] + dropMargin);
      if (!drops.length) break;
      const drop = drops[0];
      const without = roster.filter((p) => p.id !== drop.id);
      const candidate = bestAdd(without);
      const gain = candidate ? optimalTotal([...without, candidate.player], slots) - lineup.total : 0;
      if (!candidate || gain < minSwapGain) break;
      claimed.add(candidate.player.id);
      roster = [...without, asRostered(candidate.player)];
      teamMoves.push({ add: candidate.player, drop, gain });
    }
    if (teamMoves.length) moves[team.id] = teamMoves;
    return { ...team, players: roster };
  });
  return {
    league: { ...league, teams, availablePlayers: league.availablePlayers.filter((p) => !claimed.has(p.id)) },
    moves
  };
}
function depthScoreFor(bench, replacement) {
  return bench.reduce((n, p) => n + Math.max(0, p.projection - (replacement[p.position] ?? 0)), 0);
}
function analyzeOne(team, league, replacement, benchmarks, all, config) {
  const me = all.find((a) => a.team.id === team.id);
  const others = all.filter((a) => a.team.id !== team.id).map((a) => ({ teamId: a.team.id, players: a.team.players, marginal: a.marginal }));
  const weaknesses = analyzeWeaknesses(me.optimal, {
    slots: league.settings.lineupSlots,
    replacement: replacement.levels,
    benchmarks,
    otherTeams: others,
    teamCount: league.settings.teamCount,
    config
  });
  const surplus = analyzeSurplus(team.players, me.optimal, me.marginal, replacement.levels, config);
  const starters = me.optimal.starters;
  const bench = me.optimal.bench;
  return {
    teamId: team.id,
    teamName: team.name,
    isUser: team.id === league.userTeamId,
    roster: team.players,
    optimal: me.optimal,
    optimalStartingProjection: me.optimal.total,
    starters,
    bench,
    weaknesses,
    holes: weaknesses.filter((w) => w.isHole && OFFENSE_POSITIONS.some((p) => w.eligible.includes(p))),
    positionalSurplus: surplus,
    need: positionalNeed(weaknesses),
    playerMarginalValues: me.marginal,
    totalTradeValue: totalTradeValue(team.players),
    startersTradeValue: totalTradeValue(starters),
    benchTradeValue: totalTradeValue(bench),
    depthScore: depthScoreFor(bench, replacement.levels),
    projectionRank: 0,
    tradeValueRank: 0,
    waiverMoves: [],
    baselineAddedIds: []
  };
}
function analyzeLeague(originalLeague, overrides) {
  const config = mergeConfig(overrides);
  const { league, moves } = applyFreeWaiverMoves(originalLeague, config.baselineWaiverMoves, config.holeMarginPoints, config.minWaiverMoveGain);
  const slots = league.settings.lineupSlots;
  const replacement = computeReplacementLevels(league);
  const all = league.teams.map((team) => ({
    team,
    optimal: optimizeLineup(team.players, slots),
    marginal: computeMarginalValues(team.players, slots)
  }));
  const benchmarks = computeSlotBenchmarks(all.map((a) => a.optimal));
  const teams = league.teams.map((team) => ({
    ...analyzeOne(team, league, replacement, benchmarks, all, config),
    waiverMoves: moves[team.id] ?? [],
    baselineAddedIds: (moves[team.id] ?? []).map((m) => m.add.id)
  }));
  const byProj = [...teams].sort((a, b) => b.optimalStartingProjection - a.optimalStartingProjection);
  byProj.forEach((t, i) => t.projectionRank = i + 1);
  const byValue = [...teams].sort((a, b) => b.totalTradeValue - a.totalTradeValue);
  byValue.forEach((t, i) => t.tradeValueRank = i + 1);
  const user = teams.find((t) => t.isUser) ?? null;
  return {
    league,
    originalLeague,
    config,
    teams,
    user,
    replacement,
    benchmarks,
    insight: user ? buildInsight(user, teams.length, replacement) : []
  };
}
function ordinal$1(n) {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  const suffix = { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th";
  return `${n}${suffix}`;
}
function buildInsight(user, teamCount, replacement) {
  const lines = [];
  const trapped = user.positionalSurplus.filter((s) => OFFENSE_POSITIONS.includes(s.position) && s.trappedTradeValue > 0).sort((a, b) => b.trappedTradeValue - a.trappedTradeValue);
  const holes = user.holes.map((h) => h.key);
  const valueRank = ordinal$1(user.tradeValueRank);
  const projRank = ordinal$1(user.projectionRank);
  let head = `Your team has the league's ${valueRank}-highest total trade value ($${Math.round(user.totalTradeValue)}) and your optimal starting lineup ranks ${projRank} of ${teamCount} (${user.optimalStartingProjection.toFixed(1)} projected points).`;
  if (user.tradeValueRank < user.projectionRank && trapped.length) {
    const t = trapped[0];
    head = `Your team has the league's ${valueRank}-highest total trade value, but your starting lineup ranks ${projRank} because $${Math.round(t.trappedTradeValue)} of value is trapped on your bench at ${t.position}`;
    head += holes.length ? ` while your ${joinKeys(holes)} ${holes.length > 1 ? "are" : "is"} near replacement level.` : ".";
  } else if (holes.length) {
    head += ` Your ${joinKeys(holes)} ${holes.length > 1 ? "are" : "is"} near replacement level.`;
  }
  lines.push(head);
  const bigSurplus = user.positionalSurplus.filter((s) => s.level === "high" || s.level === "very high");
  if (bigSurplus.length) {
    lines.push(
      `Surplus: ${bigSurplus.map((s) => `${s.position} (${s.level}, ${s.trappedProjection.toFixed(1)} bench points above replacement)`).join(", ")}.`
    );
  }
  const worst = user.weaknesses.filter((w) => w.severity > 0 && OFFENSE_POSITIONS.some((p) => w.eligible.includes(p)))[0];
  if (worst) {
    lines.push(
      `Biggest opportunity: ${worst.key} (${worst.projection.toFixed(1)} projected, replacement ${worst.replacementProjection.toFixed(1)}) with realistic upgrades worth +${worst.upgradeRange.low.toFixed(1)} to +${worst.upgradeRange.high.toFixed(1)}.`
    );
  }
  const estimated = Object.entries(replacement.source).filter(([, s]) => s === "estimated").map(([p]) => p);
  if (estimated.length) lines.push(`Replacement level for ${estimated.join("/")} was estimated from the league's rostered pool (no waiver list available).`);
  return lines;
}
function joinKeys(keys) {
  if (keys.length <= 1) return keys.join("");
  return `${keys.slice(0, -1).join(", ")} and ${keys[keys.length - 1]}`;
}
function rankPartners(analysis, user) {
  const surplusOf = (t, pos) => {
    var _a;
    return ((_a = t.positionalSurplus.find((s) => s.position === pos)) == null ? void 0 : _a.score) ?? 0;
  };
  return analysis.teams.filter((t) => t.teamId !== user.teamId).map((t) => {
    const userGets = [];
    const partnerGets = [];
    let score = 0;
    for (const pos of OFFENSE_POSITIONS) {
      const a = Math.min(user.need[pos], surplusOf(t, pos));
      const b = Math.min(t.need[pos], surplusOf(user, pos));
      if (a > 0.5) userGets.push(pos);
      if (b > 0.5) partnerGets.push(pos);
      score += a + b;
    }
    return { teamId: t.teamId, teamName: t.teamName, score: score + 0.01, userGets, partnerGets };
  }).sort((a, b) => b.score - a.score);
}
function tradeable(players, excludeIds = /* @__PURE__ */ new Set(), minQbTradeValue = 0) {
  return players.filter(
    (p) => OFFENSE_POSITIONS.includes(p.position) && p.projectionSource === "dataset" && !p.projectionStale && p.projection > 0 && p.tradeValue > 0 && (p.position !== "QB" || p.tradeValue > minQbTradeValue) && !excludeIds.has(p.id)
  );
}
function combinations$1(items, k) {
  const out = [];
  const rec = (start, acc) => {
    if (acc.length === k) {
      out.push([...acc]);
      return;
    }
    for (let i = start; i < items.length; i++) {
      acc.push(items[i]);
      rec(i + 1, acc);
      acc.pop();
    }
  };
  rec(0, []);
  return out;
}
function valueWithinTolerance(sent, received, config) {
  const diff = Math.abs(sent - received);
  const slack = Math.max(
    config.tradeValueAbsoluteSlack,
    config.maxTradeValueDifferencePercent / 100 * Math.max(sent, received)
  );
  return diff <= slack + 1e-9;
}
function weakestStarterByPosition(team) {
  const out = { QB: Infinity, RB: Infinity, WR: Infinity, TE: Infinity, K: Infinity, DST: Infinity };
  for (const a of team.optimal.assignments) {
    for (const pos of a.slot.eligible) out[pos] = Math.min(out[pos], a.projection);
  }
  return out;
}
function generateCandidates(analysis, config) {
  const user = analysis.user;
  const stats = { partners: 0, enumerated: 0, prunedByValue: 0, prunedByLineup: 0, candidates: 0 };
  if (!user) return { candidates: [], partners: [], stats };
  const partners = rankPartners(analysis, user).slice(0, config.maxPartners);
  stats.partners = partners.length;
  const userWeakest = weakestStarterByPosition(user);
  expandSlots(analysis.league.settings.lineupSlots).length;
  const outgoingPool = tradeable(user.roster, new Set(user.baselineAddedIds), config.minQbTradeValue).sort((a, b) => b.tradeValue - a.tradeValue || b.projection - a.projection).slice(0, config.maxOutgoingCandidates);
  const candidates = [];
  for (const partner of partners) {
    const team = analysis.teams.find((t) => t.teamId === partner.teamId);
    const partnerWeakest = weakestStarterByPosition(team);
    const incomingPool = tradeable(team.roster, new Set(team.baselineAddedIds), config.minQbTradeValue).sort((a, b) => b.tradeValue - a.tradeValue || b.projection - a.projection).slice(0, config.maxIncomingCandidates);
    const poolFor = (pool2, size) => size >= 3 ? pool2.slice(0, config.maxTripleCandidates) : pool2;
    const sendSets = /* @__PURE__ */ new Map();
    const recvSets = /* @__PURE__ */ new Map();
    for (const shape of config.shapes) {
      if (!sendSets.has(shape.send)) sendSets.set(shape.send, combinations$1(poolFor(outgoingPool, shape.send), shape.send));
      if (!recvSets.has(shape.receive)) recvSets.set(shape.receive, combinations$1(poolFor(incomingPool, shape.receive), shape.receive));
    }
    for (const shape of config.shapes) {
      for (const sends of sendSets.get(shape.send)) {
        const sentValue = sends.reduce((n, p) => n + p.tradeValue, 0);
        const sendsCanStart = sends.some((p) => p.projection > partnerWeakest[p.position] + 1e-9);
        for (const recvs of recvSets.get(shape.receive)) {
          stats.enumerated++;
          const recvValue = recvs.reduce((n, p) => n + p.tradeValue, 0);
          if (config.enforceValueTolerance && !valueWithinTolerance(sentValue, recvValue, config)) {
            stats.prunedByValue++;
            continue;
          }
          const recvCanStart = recvs.some((p) => p.projection > userWeakest[p.position] + 1e-9);
          if (!recvCanStart) {
            stats.prunedByLineup++;
            continue;
          }
          if (!sendsCanStart && sentValue <= recvValue) {
            stats.prunedByLineup++;
            continue;
          }
          candidates.push({ partnerTeamId: partner.teamId, userSends: sends, userReceives: recvs, shape, partnerScore: partner.score });
        }
      }
    }
  }
  stats.candidates = candidates.length;
  return { candidates, partners, stats };
}
function countHoles(lineup, analysis) {
  const cfg = analysis.config;
  let holes = 0;
  const holeKeys = /* @__PURE__ */ new Set();
  const holeMap = /* @__PURE__ */ new Map();
  for (const a of lineup.assignments) {
    if (!OFFENSE_POSITIONS.some((p) => a.slot.eligible.includes(p))) continue;
    const repl = replacementForSlot(analysis.replacement.levels, a.slot.eligible);
    const key = `${a.slot.slotId}#${a.slot.index}`;
    holeMap.set(key, a.projection);
    if (a.player === null || a.projection - repl <= cfg.holeMarginPoints) {
      holes++;
      holeKeys.add(key);
    }
  }
  return { holes, holeKeys, holeMap };
}
function fitRosterToSize(roster, league, excludeIds) {
  const size = league.settings.rosterSize;
  const slots = league.settings.lineupSlots;
  let current = [...roster];
  const adds = [];
  const drops = [];
  while (current.length > size) {
    const lineup = optimizeLineup(current, slots);
    const starterIds = new Set(lineup.starters.map((p) => p.id));
    const projected = dropCandidates(current, starterIds);
    const pool2 = current.filter((p) => !starterIds.has(p.id));
    const offense = pool2.filter((p) => OFFENSE_POSITIONS.includes(p.position));
    const choices = projected.length ? projected : offense.length ? offense : pool2.length ? pool2 : current;
    const drop = [...choices].sort((a, b) => a.projection - b.projection || a.tradeValue - b.tradeValue)[0];
    drops.push(drop);
    current = current.filter((p) => p.id !== drop.id);
  }
  if (current.length < size) {
    const taken = /* @__PURE__ */ new Set([...current.map((p) => p.id), ...excludeIds]);
    const available = league.availablePlayers.filter((p) => !taken.has(p.id) && p.projection > 0);
    while (current.length < size && available.length) {
      const base = optimalTotal(current, slots);
      let best = null;
      const seen = /* @__PURE__ */ new Set();
      const byProj = [...available].sort((a, b) => b.projection - a.projection);
      for (const p of byProj) {
        if (seen.has(p.position)) continue;
        seen.add(p.position);
        const gain = optimalTotal([...current, p], slots) - base;
        if (!best || gain > best.gain + 1e-9 || Math.abs(gain - best.gain) < 1e-9 && p.projection > best.player.projection) {
          best = { player: p, gain };
        }
      }
      if (!best) break;
      adds.push(best.player);
      current.push(best.player);
      available.splice(available.indexOf(best.player), 1);
    }
  }
  return { roster: current, adds, drops };
}
function rankedSlotProjections(lineup) {
  const grouped = /* @__PURE__ */ new Map();
  for (const a of lineup.assignments) {
    const g = grouped.get(a.slot.slotId) ?? { label: a.slot.label, values: [] };
    g.values.push(a.projection);
    grouped.set(a.slot.slotId, g);
  }
  const out = /* @__PURE__ */ new Map();
  for (const g of grouped.values()) {
    const sorted = [...g.values].sort((x, y) => y - x);
    sorted.forEach((v, i) => out.set(sorted.length > 1 ? `${g.label}${i + 1}` : g.label, v));
  }
  return out;
}
function solvedWeaknessKeys(team, before, after, config) {
  const b = rankedSlotProjections(before);
  const a = rankedSlotProjections(after);
  const real = team.weaknesses.filter((w, i) => w.severity > 0 && (w.isHole || i < config.weaknessSolveTopN) && OFFENSE_POSITIONS.some((p) => w.eligible.includes(p)));
  return real.filter((w) => (a.get(w.key) ?? 0) - (b.get(w.key) ?? 0) >= config.weaknessSolveMinGain - 1e-9).map((w) => w.key);
}
function diffLineups(before, after) {
  var _a, _b;
  const changes = [];
  for (let i = 0; i < before.assignments.length; i++) {
    const b = before.assignments[i];
    const a = after.assignments[i];
    if ((((_a = b.player) == null ? void 0 : _a.id) ?? null) === (((_b = a.player) == null ? void 0 : _b.id) ?? null)) continue;
    changes.push({
      key: b.slot.key,
      before: b.player,
      after: a.player,
      beforeProjection: b.projection,
      afterProjection: a.projection,
      delta: a.projection - b.projection
    });
  }
  return changes;
}
function simulateSide(team, sends, receives, analysis, config) {
  const league = analysis.league;
  const slots = league.settings.lineupSlots;
  const traded = new Set([...sends, ...receives].map((p) => p.id));
  const raw = withPlayers(team.roster, sends, receives);
  const fitted = fitRosterToSize(raw, league, traded);
  const after = optimizeLineup(fitted.roster, slots);
  const before = team.optimal;
  const beforeHoles = countHoles(before, analysis);
  const afterHoles = countHoles(after, analysis);
  let recovered = 0;
  for (const key of beforeHoles.holeKeys) {
    const b = beforeHoles.holeMap.get(key) ?? 0;
    const a = afterHoles.holeMap.get(key) ?? 0;
    recovered += Math.max(0, a - b);
  }
  const beforeStarterIds = new Set(before.starters.map((p) => p.id));
  const afterStarterIds = new Set(after.starters.map((p) => p.id));
  const sent = sends.reduce((n, p) => n + p.tradeValue, 0);
  const received = receives.reduce((n, p) => n + p.tradeValue, 0);
  return {
    teamId: team.teamId,
    teamName: team.teamName,
    before,
    after,
    projectionBefore: before.total,
    projectionAfter: after.total,
    projectionGain: after.total - before.total,
    tradeValueSent: sent,
    tradeValueReceived: received,
    tradeValueGain: received - sent,
    incomingStarters: receives.filter((p) => afterStarterIds.has(p.id)),
    outgoingStarters: sends.filter((p) => beforeStarterIds.has(p.id)),
    outgoingExpendable: sends.filter((p) => (team.playerMarginalValues[p.id] ?? 0) <= config.expendableMarginalValue),
    waiverAdds: fitted.adds,
    drops: fitted.drops,
    slotChanges: diffLineups(before, after),
    holesBefore: beforeHoles.holes,
    holesAfter: afterHoles.holes,
    holePointsRecovered: recovered,
    depthBefore: team.depthScore,
    depthAfter: depthScoreFor(after.bench, analysis.replacement.levels),
    rosterAfter: fitted.roster,
    solvedWeaknesses: solvedWeaknessKeys(team, before, after, config)
  };
}
function simulateTrade(candidate, analysis) {
  const user = analysis.user;
  if (!user) throw new Error("No user team in analysis");
  const opponent = analysis.teams.find((t) => t.teamId === candidate.partnerTeamId);
  if (!opponent) throw new Error(`Unknown partner ${candidate.partnerTeamId}`);
  return {
    candidate,
    user: simulateSide(user, candidate.userSends, candidate.userReceives, analysis, analysis.config),
    opponent: simulateSide(opponent, candidate.userReceives, candidate.userSends, analysis, analysis.config)
  };
}
const TIER_RANK = { "win-win": 0, mutual: 1, "one-sided": 2 };
const TIER_LABEL = {
  "win-win": "Win/win",
  mutual: "Mutual gain",
  "one-sided": "Fair, one-sided"
};
function classifyTier(sim, config) {
  const u = sim.user;
  const o = sim.opponent;
  const userSolves = u.solvedWeaknesses.length > 0 || u.holesAfter < u.holesBefore;
  const oppSolves = o.solvedWeaknesses.length > 0 || o.holesAfter < o.holesBefore;
  if (u.projectionGain >= config.minUserGain && o.projectionGain >= config.winWinMinOpponentGain && userSolves && oppSolves) return "win-win";
  if (u.projectionGain >= config.minUserGain && o.projectionGain >= config.clearOpponentGain) return "mutual";
  return "one-sided";
}
const clamp01 = (x) => Math.max(0, Math.min(1, x));
function evaluateAcceptance(sim, config) {
  const sent = sim.user.tradeValueSent;
  const received = sim.user.tradeValueReceived;
  const diff = Math.abs(sent - received);
  const ratio = Math.max(sent, received) > 0 ? Math.min(sent, received) / Math.max(sent, received) : 1;
  const rejections = [];
  const reasons = [];
  const opp = sim.opponent;
  if (sim.user.projectionGain < config.minUserGain) {
    rejections.push(`user lineup gain ${sim.user.projectionGain.toFixed(1)} is below the ${config.minUserGain} minimum`);
  }
  if (config.enforceValueTolerance && !valueWithinTolerance(sent, received, config)) {
    rejections.push(`trade value gap $${diff.toFixed(0)} exceeds the tolerance`);
  }
  if (opp.projectionGain < -config.maxOpponentLoss) {
    rejections.push(`opponent lineup would lose ${(-opp.projectionGain).toFixed(1)} points`);
  }
  const nearNeutral = opp.projectionGain >= -config.maxOpponentLossForSecondaryReasons;
  const nonNegative = opp.projectionGain > -1e-9;
  if (opp.projectionGain >= config.clearOpponentGain) {
    reasons.push(`their optimal lineup gains +${opp.projectionGain.toFixed(1)} projected points`);
  }
  const valueNeeded = Math.max(config.opponentValueGainThreshold, config.opponentValueGainPercent / 100 * opp.tradeValueSent);
  if (nearNeutral && opp.tradeValueGain >= valueNeeded) {
    reasons.push(`they gain $${opp.tradeValueGain.toFixed(0)} in trade value${nonNegative ? "" : " for a negligible lineup cost"}`);
  }
  if (nearNeutral && opp.holesAfter < opp.holesBefore) {
    reasons.push(`it fills ${opp.holesBefore - opp.holesAfter} near-replacement starting slot${opp.holesBefore - opp.holesAfter > 1 ? "s" : ""}`);
  }
  if (nonNegative && opp.depthAfter > opp.depthBefore + 1) {
    reasons.push(`their useful bench depth rises by ${(opp.depthAfter - opp.depthBefore).toFixed(1)} points above replacement`);
  }
  if (nonNegative && sim.candidate.userSends.length < sim.candidate.userReceives.length && opp.tradeValueGain >= 0) {
    reasons.push("they consolidate two roster spots into one without losing lineup points");
  }
  if (reasons.length === 0) {
    rejections.push("no rational benefit for the opponent");
  }
  return { accepted: rejections.length === 0, opponentReasons: reasons, rejections, fairnessRatio: ratio, tradeValueDifference: diff };
}
function scoreTrade(sim, config) {
  const w = config.weights;
  const userGain = sim.user.projectionGain;
  const weaknessBonus = clamp01(sim.user.holePointsRecovered / config.weaknessScalePoints) * w.weaknessCap;
  const opponentWeaknessBonus = clamp01(sim.opponent.holePointsRecovered / config.weaknessScalePoints) * w.opponentWeaknessCap;
  const mutualBonus = clamp01(sim.opponent.projectionGain / config.mutualScalePoints) * w.mutualCap;
  const sent = sim.user.tradeValueSent;
  const received = sim.user.tradeValueReceived;
  const slack = Math.max(config.tradeValueAbsoluteSlack, config.maxTradeValueDifferencePercent / 100 * Math.max(sent, received, 1));
  const fairnessBonus = clamp01(1 - Math.abs(sent - received) / slack) * w.fairnessCap;
  const depthDelta = sim.user.depthAfter - sim.user.depthBefore;
  const depthBonus = clamp01(0.5 + depthDelta / (2 * config.depthScalePoints)) * w.depthCap;
  const total = userGain + weaknessBonus + opponentWeaknessBonus + mutualBonus + fairnessBonus + depthBonus;
  return { tier: classifyTier(sim, config), userGain, weaknessBonus, opponentWeaknessBonus, mutualBonus, fairnessBonus, depthBonus, total, band: secondaryBand(config) };
}
function compareRanked(a, b, config) {
  if (config.rankingMode === "winWin" && a.tier !== b.tier) return TIER_RANK[a.tier] - TIER_RANK[b.tier];
  return b.total - a.total || b.userGain - a.userGain;
}
function compareReason(higher, lower, config) {
  if (((config == null ? void 0 : config.rankingMode) ?? "winWin") === "winWin" && higher.tier !== lower.tier) {
    const why = {
      "win-win": "both lineups improve and both sides fix a starting weakness",
      mutual: "both lineups improve",
      "one-sided": "only your lineup improves"
    };
    return `is a ${TIER_LABEL[higher.tier].toLowerCase()} trade (${why[higher.tier]}) while #next is ${TIER_LABEL[lower.tier].toLowerCase()} (${why[lower.tier]})${higher.userGain < lower.userGain - 0.05 ? `, even though it gains you ${(lower.userGain - higher.userGain).toFixed(1)} fewer points` : ""}`;
  }
  const gainDiff = higher.userGain - lower.userGain;
  if (gainDiff >= higher.band) {
    return `gains you ${gainDiff.toFixed(1)} more starting-lineup points, which outweighs every secondary factor`;
  }
  const parts = [
    ["weakness fix", higher.weaknessBonus - lower.weaknessBonus],
    ["their weakness fix", higher.opponentWeaknessBonus - lower.opponentWeaknessBonus],
    ["mutual benefit", higher.mutualBonus - lower.mutualBonus],
    ["trade-value fairness", higher.fairnessBonus - lower.fairnessBonus],
    ["remaining depth", higher.depthBonus - lower.depthBonus]
  ];
  parts.sort((a, b) => b[1] - a[1]);
  if (gainDiff > 0.05 && gainDiff >= parts[0][1]) {
    return `gains you ${gainDiff.toFixed(1)} more starting-lineup points`;
  }
  if (parts[0][1] > 0) {
    return `scores higher on ${parts[0][0]} (your gains are within ${higher.band.toFixed(2)} points of each other${gainDiff < -0.05 ? `, despite ${(-gainDiff).toFixed(1)} fewer lineup points` : ""})`;
  }
  return "is effectively tied with it";
}
const fmt = (n) => n.toFixed(1);
const SLOT_ORDER = ["QB", "RB", "WR", "TE", "FLEX", "RB/WR", "WR/TE", "SFLEX", "K", "D/ST"];
function slotOrder(key) {
  var _a;
  const base = key.replace(/\d+$/, "");
  const idx = SLOT_ORDER.indexOf(base);
  return (idx === -1 ? 99 : idx) * 10 + (Number((_a = key.match(/\d+$/)) == null ? void 0 : _a[0]) || 0);
}
const signed = (n) => `${n >= 0 ? "+" : ""}${n.toFixed(1)}`;
const money$1 = (n) => `$${Math.round(n)}`;
function names(players) {
  if (players.length === 0) return "nobody";
  if (players.length === 1) return players[0].name;
  return `${players.slice(0, -1).map((p) => p.name).join(", ")} and ${players[players.length - 1].name}`;
}
function slotOf(sim, player) {
  const a = sim.after.assignments.find((x) => {
    var _a;
    return ((_a = x.player) == null ? void 0 : _a.id) === player.id;
  });
  return a ? a.slot.key : null;
}
function describeSide(sim, team, sends, receives, who) {
  const lines = [];
  const possessive = who === "You" ? "your" : "their";
  const surplus = team.positionalSurplus.filter((s) => s.level === "high" || s.level === "very high").map((s) => s.position);
  const bySlotOrder = (a, b) => slotOrder(a) - slotOrder(b);
  const holes = team.holes.map((h) => h.key).sort(bySlotOrder);
  const weak = team.weaknesses.filter((w) => w.severity > 2 && !w.isHole).slice(0, 2).map((w) => w.key).sort(bySlotOrder);
  const construction = [];
  if (surplus.length) construction.push(`excess ${surplus.join("/")} depth`);
  if (holes.length) construction.push(`${holes.length > 1 ? "near-replacement starters at" : "a near-replacement starter at"} ${holes.join(", ")}`);
  else if (weak.length) construction.push(`a weak ${weak.join(" and ")}`);
  if (construction.length) lines.push(`${who} have ${construction.join(" and ")}.`);
  for (const p of sends) {
    const marginal = team.playerMarginalValues[p.id] ?? 0;
    if (marginal <= 0.05) lines.push(`${p.name} is currently outside ${possessive} optimal lineup (marginal value 0.0).`);
    else if (marginal <= 3) lines.push(`${p.name} starts for ${who === "You" ? "you" : "them"} but is worth only ${fmt(marginal)} marginal lineup points.`);
    else lines.push(`${p.name} starts for ${who === "You" ? "you" : "them"} (${fmt(marginal)} marginal lineup points), so the incoming players must cover that.`);
  }
  for (const p of receives) {
    const slot2 = slotOf(sim, p);
    if (slot2) lines.push(`${p.name} becomes ${possessive} ${slot2} (${fmt(p.projection)} projected).`);
    else lines.push(`${p.name} (${fmt(p.projection)} projected) adds depth but does not start.`);
  }
  for (const add of sim.waiverAdds) lines.push(`The open roster spot is filled from waivers by ${add.name} (${fmt(add.projection)} projected).`);
  for (const drop of sim.drops) lines.push(`${drop.name} (${fmt(drop.projection)} projected) is dropped to make room.`);
  const improved = sim.slotChanges.filter((c) => c.delta > 0.05);
  const worsened = sim.slotChanges.filter((c) => c.delta < -0.05);
  if (improved.length) lines.push(`Improves: ${improved.map((c) => `${c.key} ${fmt(c.beforeProjection)} → ${fmt(c.afterProjection)}`).join(", ")}.`);
  if (worsened.length) lines.push(`Gives up: ${worsened.map((c) => `${c.key} ${fmt(c.beforeProjection)} → ${fmt(c.afterProjection)}`).join(", ")}.`);
  if (sim.holesBefore > sim.holesAfter) lines.push(`Eliminates ${sim.holesBefore - sim.holesAfter} near-replacement starting slot${sim.holesBefore - sim.holesAfter > 1 ? "s" : ""}.`);
  lines.push(`Net: ${signed(sim.projectionGain)} projected starting points (${fmt(sim.projectionBefore)} → ${fmt(sim.projectionAfter)}).`);
  return lines;
}
function explainTrade(sim, analysis, acceptance) {
  const user = analysis.user;
  const opp = analysis.teams.find((t) => t.teamId === sim.candidate.partnerTeamId);
  const sends = sim.candidate.userSends;
  const receives = sim.candidate.userReceives;
  const headline = `Send ${names(sends)} to ${opp.teamName} for ${names(receives)}: your lineup ${signed(sim.user.projectionGain)}, theirs ${signed(sim.opponent.projectionGain)}.`;
  const overall = [
    `You gain ${signed(sim.user.projectionGain)} projected starting points (${fmt(sim.user.projectionBefore)} → ${fmt(sim.user.projectionAfter)}).`,
    `${opp.teamName} ${sim.opponent.projectionGain >= 0 ? "gains" : "loses"} ${signed(sim.opponent.projectionGain)} (${fmt(sim.opponent.projectionBefore)} → ${fmt(sim.opponent.projectionAfter)}).`,
    `Trade value: you send ${money$1(sim.user.tradeValueSent)} and receive ${money$1(sim.user.tradeValueReceived)} (${acceptance.tradeValueDifference < 0.5 ? "even" : `differ by ${money$1(acceptance.tradeValueDifference)}`}).`
  ];
  if (sim.user.solvedWeaknesses.length || sim.opponent.solvedWeaknesses.length) {
    const parts = [];
    if (sim.user.solvedWeaknesses.length) parts.push(`your ${sim.user.solvedWeaknesses.join(", ")}`);
    if (sim.opponent.solvedWeaknesses.length) parts.push(`their ${sim.opponent.solvedWeaknesses.join(", ")}`);
    overall.push(`Weaknesses solved: ${parts.join(" and ")}.`);
  }
  if (acceptance.opponentReasons.length) overall.push(`Why they say yes: ${acceptance.opponentReasons.join("; ")}.`);
  return {
    headline,
    userSide: describeSide(sim.user, user, sends, receives, "You"),
    opponentSide: describeSide(sim.opponent, opp, receives, sends, "They"),
    overall
  };
}
function paginateByPartner(ranked, partnerOf, pageSize, perPartner, maxPages) {
  const entries = [];
  let remaining = ranked;
  let page = 0;
  while (remaining.length && page < maxPages) {
    page++;
    const counts = /* @__PURE__ */ new Map();
    const deferred = [];
    let taken = 0;
    for (const item of remaining) {
      const id = partnerOf(item);
      const n = counts.get(id) ?? 0;
      if (taken >= pageSize || n >= perPartner) {
        deferred.push(item);
        continue;
      }
      counts.set(id, n + 1);
      entries.push({ item, page });
      taken++;
    }
    if (taken === 0) break;
    remaining = deferred;
  }
  return { entries, pageCount: page === 0 ? 0 : entries.length ? entries[entries.length - 1].page : 0 };
}
function opponentAngle(sim) {
  const o = sim.opponent;
  if (o.projectionGain >= 0.25) return `their lineup still gains +${o.projectionGain.toFixed(1)} this week`;
  if (o.holesAfter < o.holesBefore) return `it fills a near-replacement starting slot for them`;
  const all = [...sim.candidate.userSends, ...sim.candidate.userReceives];
  const best = all.reduce((a, b) => b.tradeValue > a.tradeValue ? b : a);
  if (sim.candidate.userSends.some((p) => p.id === best.id) && sim.candidate.userSends.length < sim.candidate.userReceives.length) {
    return `they get the best player in the deal (${best.name}) and consolidate ${sim.candidate.userReceives.length} spots into ${sim.candidate.userSends.length}`;
  }
  if (sim.candidate.userSends.some((p) => p.id === best.id)) return `they get the best player in the deal (${best.name})`;
  return null;
}
function combinations(items, k) {
  const out = [];
  const rec = (start, acc) => {
    if (acc.length === k) {
      out.push([...acc]);
      return;
    }
    for (let i = start; i < items.length; i++) {
      acc.push(items[i]);
      rec(i + 1, acc);
      acc.pop();
    }
  };
  rec(0, []);
  return out;
}
function outcomeKey$1(sim) {
  const r = sim.candidate.userReceives.map((p) => p.id).sort().join(",");
  const u = sim.user.after.starters.map((p) => p.id).sort().join(",");
  return `${sim.candidate.partnerTeamId}|${r}|${u}`;
}
function findUnfairTrades(analysis, config) {
  const user = analysis.user;
  const stats = { enumerated: 0, simulated: 0, qualifying: 0, plausible: 0 };
  if (!user) return { trades: [], allTrades: [], pageCount: 0, stats };
  const outgoingPool = tradeable(user.roster, new Set(user.baselineAddedIds), config.minQbTradeValue).filter((p) => p.tradeValue > config.unfairMinOutgoingValue).sort((a, b) => b.tradeValue - a.tradeValue);
  if (!outgoingPool.length) return { trades: [], allTrades: [], pageCount: 0, stats };
  const sendSets = /* @__PURE__ */ new Map();
  for (const shape of config.shapes) {
    if (!sendSets.has(shape.send)) sendSets.set(shape.send, combinations(outgoingPool, shape.send));
  }
  const scored = [];
  const maxRatio = 1 + config.unfairMaxValueGainPercent / 100;
  const seen = /* @__PURE__ */ new Set();
  for (const team of analysis.teams) {
    if (team.teamId === user.teamId) continue;
    const incomingPool = tradeable(team.roster, new Set(team.baselineAddedIds), config.minQbTradeValue).sort((a, b) => b.tradeValue - a.tradeValue).slice(0, config.maxIncomingCandidates);
    const recvSets = /* @__PURE__ */ new Map();
    for (const shape of config.shapes) {
      const pool2 = shape.receive >= 3 ? incomingPool.slice(0, config.maxTripleCandidates) : incomingPool;
      if (!recvSets.has(shape.receive)) recvSets.set(shape.receive, combinations(pool2, shape.receive));
    }
    for (const shape of config.shapes) {
      for (const sends of sendSets.get(shape.send) ?? []) {
        const sentValue = sends.reduce((n, p) => n + p.tradeValue, 0);
        const bestSent = Math.max(...sends.map((p) => p.tradeValue));
        for (const recvs of recvSets.get(shape.receive) ?? []) {
          stats.enumerated++;
          const recvValue = recvs.reduce((n, p) => n + p.tradeValue, 0);
          if (recvValue <= sentValue) continue;
          if (recvValue > sentValue * maxRatio) continue;
          if (recvs.some((r) => r.tradeValue > bestSent || sends.some((s) => Math.abs(r.tradeValue - s.tradeValue) * 100 <= s.tradeValue * config.unfairMinValueGapPercent))) continue;
          const candidate = { partnerTeamId: team.teamId, userSends: sends, userReceives: recvs, shape, partnerScore: 0 };
          const sim = simulateTrade(candidate, analysis);
          stats.simulated++;
          if (sim.user.projectionGain <= 0) continue;
          stats.qualifying++;
          if (sim.opponent.projectionGain < -config.unfairMaxOpponentLoss) continue;
          const angle = opponentAngle(sim);
          if (config.unfairRequireOpponentAngle && !angle) continue;
          const key = outcomeKey$1(sim);
          if (seen.has(key)) continue;
          seen.add(key);
          const valueGain = recvValue - sentValue;
          stats.plausible++;
          scored.push({ sim, valueGain, angle: angle ?? "no particular angle", score: sim.user.projectionGain + valueGain / config.unfairValuePointsPerProjectionPoint });
        }
      }
    }
  }
  scored.sort((a, b) => b.score - a.score || b.valueGain - a.valueGain);
  const paged = paginateByPartner(scored, (e) => e.sim.candidate.partnerTeamId, config.unfairTopN, config.maxTradesPerPartner, config.maxPages);
  const allTrades = paged.entries.map(({ item: entry, page }, i) => {
    const acceptance = evaluateAcceptance(entry.sim, config);
    return { rank: i + 1, page, simulation: entry.sim, opponentAngle: entry.angle, valueGain: entry.valueGain, score: entry.score, acceptance, explanation: explainTrade(entry.sim, analysis, acceptance) };
  });
  const trades = allTrades.filter((t) => t.page === 1);
  return { trades, allTrades, pageCount: paged.pageCount, stats };
}
function tradeKey(sim) {
  const s = sim.candidate.userSends.map((p) => p.id).sort().join(",");
  const r = sim.candidate.userReceives.map((p) => p.id).sort().join(",");
  return `${sim.candidate.partnerTeamId}|${s}|${r}`;
}
function outcomeKey(sim) {
  const r = sim.candidate.userReceives.map((p) => p.id).sort().join(",");
  const u = sim.user.after.starters.map((p) => p.id).sort().join(",");
  const o = sim.opponent.after.starters.map((p) => p.id).sort().join(",");
  return `${sim.candidate.partnerTeamId}|${r}|${u}|${o}`;
}
function runTradeOptimizer(league, overrides) {
  const start = Date.now();
  const analysis = analyzeLeague(league, overrides);
  const config = analysis.config;
  const { candidates, partners, stats } = generateCandidates(analysis, config);
  const scored = [];
  const rejectedSamples = [];
  const seen = /* @__PURE__ */ new Set();
  let simulated = 0;
  for (const candidate of candidates) {
    const sim = simulateTrade(candidate, analysis);
    simulated++;
    const key = tradeKey(sim);
    if (seen.has(key)) continue;
    seen.add(key);
    const acceptance = evaluateAcceptance(sim, config);
    if (!acceptance.accepted) {
      if (rejectedSamples.length < 50 && sim.user.projectionGain >= config.minUserGain) rejectedSamples.push({ simulation: sim, acceptance });
      continue;
    }
    scored.push({ sim, score: scoreTrade(sim, config), acceptance });
  }
  scored.sort((a, b) => compareRanked(a.score, b.score, config));
  const seenOutcome = /* @__PURE__ */ new Set();
  const distinct = [];
  for (const entry of scored) {
    const ok = outcomeKey(entry.sim);
    if (seenOutcome.has(ok)) continue;
    seenOutcome.add(ok);
    distinct.push(entry);
  }
  const paged = paginateByPartner(distinct, (e) => e.sim.candidate.partnerTeamId, config.topN, config.maxTradesPerPartner, config.maxPages);
  const allTrades = paged.entries.map(({ item: entry, page }, i) => ({
    rank: i + 1,
    page,
    simulation: entry.sim,
    score: entry.score,
    acceptance: entry.acceptance,
    explanation: explainTrade(entry.sim, analysis, entry.acceptance),
    rankedAboveNextBecause: i + 1 < paged.entries.length ? compareReason(entry.score, paged.entries[i + 1].item.score, config).replace("#next", `#${i + 2}`) : null
  }));
  const trades = allTrades.filter((t) => t.page === 1);
  const unfair = findUnfairTrades(analysis, config);
  return {
    analysis,
    trades,
    allTrades,
    tradePageCount: paged.pageCount,
    unfairTrades: unfair.trades,
    allUnfairTrades: unfair.allTrades,
    unfairPageCount: unfair.pageCount,
    unfairStats: unfair.stats,
    partners,
    stats: { ...stats, simulated, accepted: scored.length, elapsedMs: Date.now() - start },
    rejectedSamples
  };
}
const SUFFIXES = /* @__PURE__ */ new Set(["jr", "sr", "ii", "iii", "iv", "v"]);
function normalizeName(name) {
  const ascii = (name || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/['’.`-]/g, "").replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();
  const parts = ascii.split(" ").filter((p) => p && !SUFFIXES.has(p));
  return parts.join(" ");
}
const ALIASES = {
  "hollywood brown": "marquise brown",
  "chig okonkwo": "chigoziem okonkwo",
  "josh palmer": "joshua palmer",
  "gabe davis": "gabriel davis",
  "dj moore": "d j moore",
  "ken walker": "kenneth walker",
  "mitch trubisky": "mitchell trubisky",
  "scotty miller": "scott miller",
  "cam ward": "cameron ward",
  "bucky irving": "bucky irving",
  "tank bigsby": "tank bigsby",
  "chris brooks": "christopher brooks",
  "pat freiermuth": "patrick freiermuth",
  "dk metcalf": "d k metcalf",
  "aj brown": "a j brown",
  "tj hockenson": "t j hockenson",
  "cj stroud": "c j stroud",
  "jk dobbins": "j k dobbins",
  "dj chark": "d j chark"
};
function aliasKey(key) {
  return ALIASES[key] ?? key;
}
function collapseInitials(key) {
  return key.replace(/\b([a-z]) ([a-z])\b(?= )/g, "$1$2");
}
const NFL_TEAM_NAMES = {
  ARI: "arizona cardinals",
  ATL: "atlanta falcons",
  BAL: "baltimore ravens",
  BUF: "buffalo bills",
  CAR: "carolina panthers",
  CHI: "chicago bears",
  CIN: "cincinnati bengals",
  CLE: "cleveland browns",
  DAL: "dallas cowboys",
  DEN: "denver broncos",
  DET: "detroit lions",
  GB: "green bay packers",
  HOU: "houston texans",
  IND: "indianapolis colts",
  JAX: "jacksonville jaguars",
  KC: "kansas city chiefs",
  LAC: "los angeles chargers",
  LAR: "los angeles rams",
  LV: "las vegas raiders",
  MIA: "miami dolphins",
  MIN: "minnesota vikings",
  NE: "new england patriots",
  NO: "new orleans saints",
  NYG: "new york giants",
  NYJ: "new york jets",
  PHI: "philadelphia eagles",
  PIT: "pittsburgh steelers",
  SEA: "seattle seahawks",
  SF: "san francisco 49ers",
  TB: "tampa bay buccaneers",
  TEN: "tennessee titans",
  WAS: "washington commanders"
};
const TEAM_BY_NICKNAME = /* @__PURE__ */ new Map();
const TEAM_BY_CITY = /* @__PURE__ */ new Map();
for (const [abbr, full] of Object.entries(NFL_TEAM_NAMES)) {
  const words = full.split(" ");
  TEAM_BY_NICKNAME.set(words[words.length - 1], abbr);
  TEAM_BY_CITY.set(words.slice(0, -1).join(" "), abbr);
}
function normalizeDstName(name) {
  const key = normalizeName(name.replace(/d\/st|dst|defense|def\b|special teams/gi, " "));
  if (!key) return key;
  const upper = key.toUpperCase().replace(/ /g, "");
  if (NFL_TEAM_NAMES[upper]) return upper;
  const words = key.split(" ");
  for (const w of words) {
    const abbr = TEAM_BY_NICKNAME.get(w);
    if (abbr) return abbr;
  }
  const city = TEAM_BY_CITY.get(key);
  if (city) return city;
  return key;
}
class PlayerIndex {
  constructor(entries, idNamespace, allowFuzzy = false) {
    __publicField(this, "byId", /* @__PURE__ */ new Map());
    __publicField(this, "byExact", /* @__PURE__ */ new Map());
    __publicField(this, "byNormalized", /* @__PURE__ */ new Map());
    __publicField(this, "byFuzzy", /* @__PURE__ */ new Map());
    __publicField(this, "size");
    this.idNamespace = idNamespace;
    this.allowFuzzy = allowFuzzy;
    for (const e of entries) {
      if (e.playerId) this.byId.set(e.playerId, e);
      const pos = e.position;
      this.byExact.set(`${e.name.toLowerCase()}|${pos}`, e);
      for (const key of normalizedKeys(e.name, pos)) push(this.byNormalized, `${key}|${pos}`, e);
      const fz = fuzzyKey(e.name, pos);
      if (fz) push(this.byFuzzy, fz, e);
    }
    this.size = entries.length;
  }
  find(identity) {
    if (identity.platformId) {
      const hit = this.byId.get(identity.platformId) ?? (this.idNamespace ? this.byId.get(`${this.idNamespace}:${identity.platformId}`) : void 0);
      if (hit) return { entry: hit, confidence: "id" };
    }
    const pos = identity.position;
    const exact = this.byExact.get(`${identity.name.toLowerCase()}|${pos}`);
    if (exact) return { entry: exact, confidence: "exact" };
    for (const key of normalizedKeys(identity.name, pos)) {
      const list = this.byNormalized.get(`${key}|${pos}`);
      if (list && list.length === 1) return { entry: list[0], confidence: "normalized" };
    }
    if (this.allowFuzzy) {
      const fz = fuzzyKey(identity.name, pos);
      if (fz) {
        const list = this.byFuzzy.get(fz);
        if (list && list.length === 1 && initialsCompatible(identity.name, list[0].name)) return { entry: list[0], confidence: "fuzzy" };
      }
    }
    return { entry: null, confidence: "unmatched" };
  }
}
function push(map, key, value) {
  const list = map.get(key);
  if (list) {
    if (!list.includes(value)) list.push(value);
  } else map.set(key, [value]);
}
function normalizedKeys(name, position) {
  if (position === "DST") return [normalizeDstName(name)];
  const base = normalizeName(name);
  const keys = /* @__PURE__ */ new Set([base, aliasKey(base), collapseInitials(base), aliasKey(collapseInitials(base))]);
  return [...keys].filter(Boolean);
}
function firstToken(name) {
  return collapseInitials(aliasKey(normalizeName(name))).split(" ")[0] ?? "";
}
function initialsCompatible(a, b) {
  const fa = firstToken(a);
  const fb = firstToken(b);
  if (fa.length === 1 || fb.length === 1) return true;
  return fa === fb;
}
function fuzzyKey(name, position) {
  if (position === "DST") return null;
  const key = collapseInitials(aliasKey(normalizeName(name)));
  const parts = key.split(" ");
  if (parts.length < 2) return null;
  return `${parts[0][0]} ${parts.slice(1).join(" ")}|${position}`;
}
function parsePosition(raw) {
  return normalizePosition(raw);
}
const DEFAULT_SLOPE = 2.5;
function enginePlayerId(platform, raw) {
  return `${platform}:${raw.platformId}`;
}
function estimateTradeValue(projection, position, replacement, listed, slope = DEFAULT_SLOPE, discount = 0.6) {
  if (projection <= 0 || projection <= replacement) return 0;
  const points = listed.filter((l) => l.projection > 0 && l.value > 0).sort((a, b) => a.projection - b.projection);
  if (points.length < 2) {
    return Math.max(1, Math.min(3, Math.round(slope * (projection - replacement))));
  }
  let interpolated;
  if (projection <= points[0].projection) interpolated = points[0].value;
  else if (projection >= points[points.length - 1].projection) interpolated = points[points.length - 1].value;
  else {
    let i = 0;
    while (points[i + 1].projection < projection) i++;
    const a = points[i];
    const b = points[i + 1];
    const t = b.projection === a.projection ? 0 : (projection - a.projection) / (b.projection - a.projection);
    interpolated = a.value + t * (b.value - a.value);
  }
  const values = points.map((l) => l.value).sort((a, b) => a - b);
  const lowerQuartile = values[Math.floor((values.length - 1) * 0.25)];
  return Math.max(1, Math.min(Math.round(interpolated * discount), lowerQuartile));
}
function estimateProjectionFromValue(tradeValue, curve2) {
  const pts = curve2.filter((c) => c.value > 0 && c.projection > 0).sort((a2, b2) => a2.value - b2.value);
  if (pts.length < 3 || tradeValue <= 0) return null;
  if (tradeValue <= pts[0].value) return pts[0].projection;
  if (tradeValue >= pts[pts.length - 1].value) return pts[pts.length - 1].projection;
  let i = 0;
  while (pts[i + 1].value < tradeValue) i++;
  const a = pts[i];
  const b = pts[i + 1];
  const t = b.value === a.value ? 0 : (tradeValue - a.value) / (b.value - a.value);
  return Math.round((a.projection + t * (b.projection - a.projection)) * 10) / 10;
}
function enrichLeague(raw, projections, tradeValues, options = {}) {
  const platform = raw.settings.platform;
  const projIndex = new PlayerIndex(projections.entries, options.idNamespace);
  const valueIndex = new PlayerIndex(tradeValues.entries, options.idNamespace);
  const slope = options.valuePointsPerProjectionPoint ?? DEFAULT_SLOPE;
  const unlisted = options.unlistedTradeValue ?? "estimate";
  const report = {
    rosteredPlayers: 0,
    projectionMatched: 0,
    projectionEstimated: 0,
    tradeValueMatched: 0,
    tradeValueEstimated: 0,
    unmatchedProjection: [],
    unmatchedTradeValue: [],
    availableFromDataset: 0
  };
  const usedProjectionEntries = /* @__PURE__ */ new Set();
  const convert = (rp, teamName, rostered) => {
    var _a, _b;
    const proj = projIndex.find({ platformId: rp.platformId, name: rp.name, position: rp.position });
    const val = valueIndex.find({ platformId: rp.platformId, name: rp.name, position: rp.position });
    if (rostered) {
      report.rosteredPlayers++;
      if (proj.entry) report.projectionMatched++;
      else if (OFFENSE_POSITIONS.includes(rp.position)) report.unmatchedProjection.push({ name: rp.name, position: rp.position, teamName });
      if (val.entry) report.tradeValueMatched++;
      else if (OFFENSE_POSITIONS.includes(rp.position)) report.unmatchedTradeValue.push({ name: rp.name, position: rp.position, teamName });
    }
    if (proj.entry) usedProjectionEntries.add(proj.entry);
    return {
      id: enginePlayerId(platform, rp),
      platformId: rp.platformId,
      name: rp.name,
      position: rp.position,
      nflTeam: rp.nflTeam ?? ((_a = proj.entry) == null ? void 0 : _a.nflTeam),
      injuryStatus: rp.injuryStatus,
      projection: proj.entry ? proj.entry.medianProjection : 0,
      projectionSource: proj.entry ? "dataset" : "none",
      projectionStale: ((_b = proj.entry) == null ? void 0 : _b.stale) === true,
      tradeValue: val.entry ? val.entry.tradeValue : 0,
      tradeValueSource: val.entry ? "dataset" : "none",
      matchConfidence: proj.entry ? proj.confidence : val.entry ? val.confidence : "unmatched"
    };
  };
  const teams = raw.teams.map((t) => ({ id: t.id, name: t.name, ownerName: t.ownerName, players: t.players.map((p) => convert(p, t.name, true)) }));
  const rosteredIds = new Set(teams.flatMap((t) => t.players.map((p) => p.id)));
  const available = raw.availablePlayers.map((p) => convert(p, "waivers", false)).filter((p) => !rosteredIds.has(p.id));
  const availableNames = new Set(available.map((p) => `${p.name.toLowerCase()}|${p.position}`));
  for (const e of projections.entries) {
    if (usedProjectionEntries.has(e)) continue;
    const key = `${e.name.toLowerCase()}|${e.position}`;
    if (availableNames.has(key)) continue;
    availableNames.add(key);
    report.availableFromDataset++;
    available.push({
      id: `dataset:${e.playerId ?? key}`,
      platformId: e.playerId,
      name: e.name,
      position: e.position,
      nflTeam: e.nflTeam,
      projection: e.medianProjection,
      projectionSource: "dataset",
      tradeValue: 0,
      tradeValueSource: "none",
      matchConfidence: "id"
    });
  }
  for (const p of available) {
    p.tradeValue = 0;
    p.tradeValueSource = "none";
  }
  const curves = { QB: [], RB: [], WR: [], TE: [], K: [], DST: [] };
  for (const t of teams) {
    for (const p of t.players) {
      if (p.tradeValueSource === "dataset" && p.projectionSource === "dataset") curves[p.position].push({ projection: p.projection, value: p.tradeValue });
    }
  }
  for (const t of teams) {
    for (const p of t.players) {
      if (p.projectionSource !== "none" || p.tradeValueSource !== "dataset" || !OFFENSE_POSITIONS.includes(p.position)) continue;
      const est = estimateProjectionFromValue(p.tradeValue, curves[p.position]);
      if (est !== null && est > 0) {
        p.projection = est;
        p.projectionSource = "estimated";
        report.projectionEstimated++;
      }
    }
  }
  if (unlisted === "estimate") {
    const replacement = { QB: 0, RB: 0, WR: 0, TE: 0, K: 0, DST: 0 };
    for (const p of available) replacement[p.position] = Math.max(replacement[p.position], p.projection);
    for (const t of teams) {
      for (const p of t.players) {
        if (p.tradeValueSource === "dataset" || !OFFENSE_POSITIONS.includes(p.position) || p.projection <= 0) continue;
        const est = estimateTradeValue(p.projection, p.position, replacement[p.position], curves[p.position], slope);
        if (est > 0) {
          p.tradeValue = est;
          p.tradeValueSource = "estimated";
          report.tradeValueEstimated++;
        }
      }
    }
  }
  const league = {
    settings: raw.settings,
    teams,
    userTeamId: raw.userTeamId,
    userTeamDetection: raw.userTeamDetection,
    availablePlayers: available.sort((a, b) => b.projection - a.projection)
  };
  return { league, report };
}
const POSITION_BY_CODE = { 0: "QB", 1: "RB", 2: "WR", 3: "TE" };
const ALL_POSITIONS_CODE = 99;
function scoringModeFor(receptionPoints) {
  if (receptionPoints >= 0.75) return 2;
  if (receptionPoints >= 0.25) return 0;
  return 1;
}
class BettingProsProjectionSource {
  constructor() {
    __publicField(this, "id", "bettingpros");
  }
  async load(request) {
    const mode = scoringModeFor(request.scoring.receptionPoints);
    const passTdPoints = request.scoring.passTdPoints >= 5 ? 6 : 4;
    const result = await computeBPProjections({
      pos: ALL_POSITIONS_CODE,
      mode,
      week: request.week,
      year: request.season,
      passTdPoints
    });
    const entries = [];
    for (const [name, info] of result.finalList) {
      const position = POSITION_BY_CODE[info.pos];
      if (!position) continue;
      entries.push({ name, position, medianProjection: Math.round(info.ev * 100) / 100, stale: info.stale === true });
    }
    if (entries.length === 0) {
      throw new Error(`No VegasLytics projections found for ${request.season} week ${request.week} (${BP_BASE}).`);
    }
    return {
      entries,
      source: this.id,
      label: `VegasLytics medians · ${request.season} wk ${request.week} · ${["Half PPR", "Standard", "Full PPR"][mode]}${passTdPoints === 6 ? " · 6pt pass TD" : ""}`,
      fetchedAt: result.lastFetched ?? void 0
    };
  }
}
function parseProjectionJson(text) {
  const data = JSON.parse(text);
  const rows = Array.isArray(data) ? data : Array.isArray(data == null ? void 0 : data.players) ? data.players : Array.isArray(data == null ? void 0 : data.entries) ? data.entries : [];
  const out = [];
  for (const row of rows) {
    const position = parsePosition(row.position);
    const value = Number(row.medianProjection ?? row.projection ?? row.ev);
    if (!(row == null ? void 0 : row.name) || !position || !Number.isFinite(value)) continue;
    out.push({ playerId: row.playerId ? String(row.playerId) : void 0, name: row.name, position, nflTeam: row.nflTeam, medianProjection: value });
  }
  return out;
}
class StaticProjectionSource {
  constructor(entries, label = "Custom projections") {
    __publicField(this, "id", "static");
    this.entries = entries;
    this.label = label;
  }
  async load() {
    return { entries: this.entries, source: this.id, label: this.label };
  }
}
class UrlProjectionSource {
  constructor(url) {
    __publicField(this, "id", "url");
    this.url = url;
  }
  async load() {
    const res = await fetch(this.url);
    if (!res.ok) throw new Error(`Projection URL returned ${res.status}`);
    const entries = parseProjectionJson(await res.text());
    if (!entries.length) throw new Error("Projection JSON had no usable rows");
    return { entries, source: this.id, label: `Custom projections (${this.url})` };
  }
}
const TRADE_VALUES_BASE = "https://raw.githubusercontent.com/seoularpro/OddsVis/main/TradeValueSheets/json/";
function scoringKeyFor(receptionPoints) {
  if (receptionPoints >= 0.75) return "FullPPR";
  if (receptionPoints >= 0.25) return "HalfPPR";
  return "Standard";
}
function leagueSizeKeyFor(teamCount) {
  if (teamCount <= 9) return 8;
  if (teamCount <= 11) return 10;
  return 12;
}
function publishedTradeValueUrl(request, base = TRADE_VALUES_BASE) {
  return `${base}TradeValues_${scoringKeyFor(request.scoring.receptionPoints)}_${leagueSizeKeyFor(request.teamCount)}team.json`;
}
class PublishedTradeValueSource {
  constructor(base = TRADE_VALUES_BASE) {
    __publicField(this, "id", "published");
    this.base = base;
  }
  async load(request) {
    const url = publishedTradeValueUrl(request, this.base);
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Trade value file returned ${res.status} (${url})`);
    const data = await res.json();
    const entries = [];
    for (const p of data.players ?? []) {
      const position = parsePosition(p.pos);
      if (!position || !p.name) continue;
      entries.push({ name: p.name, position, tradeValue: Number(p.value) || 0 });
    }
    if (!entries.length) throw new Error("Trade value file had no players");
    return {
      entries,
      source: this.id,
      label: `VegasLytics trade values · ${data.scoringLabel ?? scoringKeyFor(request.scoring.receptionPoints)} · ${data.leagueSize ?? leagueSizeKeyFor(request.teamCount)}-team`,
      generatedAt: data.generatedAt
    };
  }
}
function parseTradeValueJson(text) {
  const data = JSON.parse(text);
  const rows = Array.isArray(data) ? data : Array.isArray(data == null ? void 0 : data.players) ? data.players : Array.isArray(data == null ? void 0 : data.entries) ? data.entries : [];
  const out = [];
  for (const row of rows) {
    const position = parsePosition(row.position ?? row.pos);
    const value = Number(row.tradeValue ?? row.value);
    if (!(row == null ? void 0 : row.name) || !position || !Number.isFinite(value)) continue;
    out.push({ playerId: row.playerId ? String(row.playerId) : void 0, name: row.name, position, nflTeam: row.nflTeam, tradeValue: value });
  }
  return out;
}
class StaticTradeValueSource {
  constructor(entries, label = "Custom trade values") {
    __publicField(this, "id", "static");
    this.entries = entries;
    this.label = label;
  }
  async load() {
    return { entries: this.entries, source: this.id, label: this.label };
  }
}
class UrlTradeValueSource {
  constructor(url) {
    __publicField(this, "id", "url");
    this.url = url;
  }
  async load() {
    const res = await fetch(this.url);
    if (!res.ok) throw new Error(`Trade value URL returned ${res.status}`);
    const entries = parseTradeValueJson(await res.text());
    if (!entries.length) throw new Error("Trade value JSON had no usable rows");
    return { entries, source: this.id, label: `Custom trade values (${this.url})` };
  }
}
function positionsIn(entries) {
  return [...new Set(entries.map((e) => e.position))];
}
let counter = 0;
function makePlayer(name, position, projection, tradeValue, id) {
  counter++;
  return {
    id: id ?? `fixture:${position.toLowerCase()}-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${counter}`,
    name,
    position,
    projection,
    projectionSource: projection > 0 ? "dataset" : "none",
    tradeValue,
    tradeValueSource: tradeValue > 0 ? "dataset" : "none",
    matchConfidence: "id"
  };
}
function makeLeague(opts) {
  const slots = opts.slots ?? standardLineup();
  const maxRoster = Math.max(...opts.teams.map((t) => t.players.length));
  return {
    settings: {
      platform: "fixture",
      leagueId: "fixture",
      leagueName: "Fixture League",
      season: 2026,
      week: 1,
      teamCount: opts.teamCount ?? opts.teams.length,
      rosterSize: opts.rosterSize ?? maxRoster,
      scoring: { receptionPoints: opts.receptionPoints ?? 0.5, passTdPoints: 4 },
      lineupSlots: slots
    },
    teams: opts.teams.map((t) => ({ id: t.id, name: t.name, players: t.players })),
    userTeamId: opts.userTeamId,
    userTeamDetection: "manual",
    availablePlayers: opts.availablePlayers ?? []
  };
}
function curve(position, rank) {
  switch (position) {
    case "QB": {
      const projection = Math.max(8, 24.5 - 0.75 * rank - (rank > 12 ? 1.5 : 0));
      const tradeValue = rank <= 3 ? 40 - 5 * (rank - 1) : rank <= 12 ? Math.max(4, 24 - 2 * rank) : 1;
      return { projection: r1(projection), tradeValue };
    }
    case "RB": {
      const projection = Math.max(3, 21.5 - 0.42 * rank - (rank > 24 ? 2 : 0));
      const tradeValue = rank <= 2 ? 70 - 4 * (rank - 1) : rank <= 12 ? Math.max(20, 62 - 3.6 * rank) : rank <= 30 ? Math.max(3, 26 - 0.9 * rank) : 1;
      return { projection: r1(projection), tradeValue: Math.round(tradeValue) };
    }
    case "WR": {
      const projection = Math.max(3, 19.5 - 0.33 * rank - (rank > 30 ? 2 : 0));
      const tradeValue = rank <= 3 ? 62 - 4 * (rank - 1) : rank <= 15 ? Math.max(18, 56 - 2.8 * rank) : rank <= 36 ? Math.max(3, 24 - 0.7 * rank) : 1;
      return { projection: r1(projection), tradeValue: Math.round(tradeValue) };
    }
    case "TE": {
      const projection = Math.max(3, 14.5 - 0.7 * rank - (rank > 12 ? 1 : 0));
      const tradeValue = rank <= 2 ? 30 - 6 * (rank - 1) : rank <= 8 ? Math.max(6, 20 - 2 * rank) : 1;
      return { projection: r1(projection), tradeValue };
    }
    default:
      return { projection: 0, tradeValue: 0 };
  }
}
function r1(n) {
  return Math.round(n * 10) / 10;
}
const FIRST = ["Jalen", "Marcus", "Devin", "Tyler", "Aaron", "Chris", "Jordan", "Kyle", "Trey", "Brandon", "Elijah", "Cam", "Derek", "Amari", "Nico", "Zay", "Rome", "Malik", "Isaiah", "Josh"];
const LAST = ["Carter", "Reed", "Bell", "Hayes", "Price", "Ford", "Wells", "Grant", "Cole", "Hunt", "Diaz", "Lane", "Moss", "Pace", "Quinn", "Ross", "Stone", "Tate", "Vance", "Wade"];
function pool(position, count, prefix) {
  const out = [];
  for (let rank = 1; rank <= count; rank++) {
    const { projection, tradeValue } = curve(position, rank);
    const name = `${FIRST[(rank * 7 + position.length) % FIRST.length]} ${LAST[(rank * 3 + position.charCodeAt(0)) % LAST.length]} (${position}${rank})`;
    out.push(makePlayer(name, position, projection, tradeValue, `fixture:${prefix}${rank}`));
  }
  return out;
}
function syntheticLeague() {
  counter = 0;
  const qbs = pool("QB", 22, "qb");
  const rbs = pool("RB", 54, "rb");
  const wrs = pool("WR", 58, "wr");
  const tes = pool("TE", 22, "te");
  const ks = Array.from({ length: 10 }, (_, i) => makePlayer(`Kicker ${i + 1}`, "K", 0, 0, `fixture:k${i + 1}`));
  const dsts = Array.from({ length: 10 }, (_, i) => makePlayer(`Defense ${i + 1}`, "DST", 0, 0, `fixture:dst${i + 1}`));
  const take = (list, ranks) => ranks.map((r) => list[r - 1]);
  const used = /* @__PURE__ */ new Set();
  const claim = (players) => {
    players.forEach((p) => used.add(p.id));
    return players;
  };
  const teamsSpec = [
    {
      id: "u",
      name: "My Team",
      players: claim([...take(qbs, [6]), ...take(rbs, [2, 5, 9, 13, 20]), ...take(wrs, [12, 24, 31, 38]), ...take(tes, [7, 13]), ks[0], dsts[0]])
    },
    {
      id: "rocket",
      name: "Team Rocket",
      players: claim([...take(qbs, [4]), ...take(rbs, [16, 27, 35]), ...take(wrs, [1, 4, 8, 11, 18, 27]), ...take(tes, [3, 12]), ks[1], dsts[1]])
    },
    {
      id: "stars",
      name: "Stars & Scrubs",
      players: claim([...take(qbs, [1, 14]), ...take(rbs, [1, 29, 34, 40]), ...take(wrs, [3, 33, 36, 42]), ...take(tes, [10]), ks[2], dsts[2]])
    },
    {
      id: "depth",
      name: "Balanced Depth",
      players: claim([...take(qbs, [7, 9]), ...take(rbs, [6, 8, 11, 15]), ...take(wrs, [6, 9, 13, 16, 21]), ...take(tes, [4]), ks[3], dsts[3]])
    }
  ];
  const remaining = (list) => list.filter((p) => !used.has(p.id));
  const others = ["Gridiron Gang", "Waiver Warriors", "Flex Appeal", "The Replacements", "End Zone Elite", "Bench Mob"];
  const needs = { QB: 2, RB: 5, WR: 5, TE: 2 };
  const draft = {};
  others.forEach((n) => draft[n] = []);
  const lists = { QB: remaining(qbs), RB: remaining(rbs), WR: remaining(wrs), TE: remaining(tes) };
  for (const pos of ["QB", "RB", "WR", "TE"]) {
    let order = [...others];
    for (let round = 0; round < needs[pos]; round++) {
      for (const teamName of order) {
        const next = lists[pos].shift();
        if (next) draft[teamName].push(next);
      }
      order = order.reverse();
    }
  }
  others.forEach((name, i) => {
    teamsSpec.push({ id: `t${i + 5}`, name, players: claim([...draft[name], ks[4 + i], dsts[4 + i]]) });
  });
  const teams = teamsSpec.map((t) => ({ id: t.id, name: t.name, players: t.players.slice(0, 15) }));
  const availablePlayers = [...remaining(qbs), ...remaining(rbs), ...remaining(wrs), ...remaining(tes)].filter((p) => !teams.some((t) => t.players.some((q) => q.id === p.id))).map((p) => ({ ...p, tradeValue: 0, tradeValueSource: "none" }));
  return makeLeague({ teams, userTeamId: "u", rosterSize: 15, availablePlayers, teamCount: 10 });
}
class AdapterError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
    this.name = "AdapterError";
  }
}
const ESPN_BENCH_SLOT = 20;
const ESPN_IR_SLOT = 21;
const ESPN_SLOT_TO_LINEUP = {
  0: SLOT_PRESETS.QB,
  1: null,
  // TQB
  2: SLOT_PRESETS.RB,
  3: SLOT_PRESETS["RB/WR"],
  4: SLOT_PRESETS.WR,
  5: SLOT_PRESETS["WR/TE"],
  6: SLOT_PRESETS.TE,
  7: SLOT_PRESETS.SUPERFLEX,
  // OP
  16: SLOT_PRESETS.DST,
  17: SLOT_PRESETS.K,
  23: SLOT_PRESETS.FLEX
};
const ESPN_POSITION_BY_DEFAULT_ID = {
  1: "QB",
  2: "RB",
  3: "WR",
  4: "TE",
  5: "K",
  16: "DST"
};
const ESPN_PRO_TEAMS = {
  1: "ATL",
  2: "BUF",
  3: "CHI",
  4: "CIN",
  5: "CLE",
  6: "DAL",
  7: "DEN",
  8: "DET",
  9: "GB",
  10: "TEN",
  11: "IND",
  12: "KC",
  13: "LV",
  14: "LAR",
  15: "MIA",
  16: "MIN",
  17: "NE",
  18: "NO",
  19: "NYG",
  20: "NYJ",
  21: "PHI",
  22: "ARI",
  23: "PIT",
  24: "LAC",
  25: "SF",
  26: "SEA",
  27: "TB",
  28: "WAS",
  29: "CAR",
  30: "JAX",
  33: "BAL",
  34: "HOU"
};
const ESPN_STAT_RECEPTIONS = 53;
const ESPN_STAT_PASS_TD = 4;
function espnSeasonFromDate(date = /* @__PURE__ */ new Date()) {
  return date.getMonth() >= 4 ? date.getFullYear() : date.getFullYear() - 1;
}
function espnLineupSlots(counts) {
  const slots = [];
  const skipped = [];
  let rosterSize = 0;
  for (const [idStr, count] of Object.entries(counts)) {
    const id = Number(idStr);
    if (!count) continue;
    if (id === ESPN_IR_SLOT) continue;
    if (id === ESPN_BENCH_SLOT) {
      rosterSize += count;
      continue;
    }
    const preset = ESPN_SLOT_TO_LINEUP[id];
    if (!preset) {
      skipped.push(`slot ${id}`);
      continue;
    }
    rosterSize += count;
    slots.push({ ...preset, count });
  }
  const order = ["QB", "RB", "WR", "TE", "FLEX", "RB/WR", "WR/TE", "SUPERFLEX", "K", "DST"];
  slots.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
  return { slots, rosterSize, skipped };
}
function espnScoring(items) {
  const find = (statId) => {
    var _a;
    return (_a = items == null ? void 0 : items.find((i) => i.statId === statId)) == null ? void 0 : _a.points;
  };
  return {
    receptionPoints: find(ESPN_STAT_RECEPTIONS) ?? 0,
    passTdPoints: find(ESPN_STAT_PASS_TD) ?? 4
  };
}
function espnTeamName(team) {
  const name = typeof team.name === "string" ? team.name.trim() : "";
  if (name) return name;
  const legacy = [team.location, team.nickname].filter(Boolean).join(" ").trim();
  return legacy || team.abbrev || `Team ${team.id}`;
}
function espnRawPlayer(player, fallbackId) {
  if (!player) return null;
  const position = ESPN_POSITION_BY_DEFAULT_ID[player.defaultPositionId ?? -1];
  if (!position) return null;
  return {
    platformId: String(player.id ?? fallbackId),
    name: player.fullName ?? `Player ${player.id ?? fallbackId}`,
    position,
    nflTeam: player.proTeamId ? ESPN_PRO_TEAMS[player.proTeamId] : void 0,
    injuryStatus: player.injuryStatus
  };
}
function normalizeEspnLeague(payload, leagueId) {
  var _a, _b, _c, _d, _e, _f, _g;
  const warnings = [];
  const counts = (_b = (_a = payload.settings) == null ? void 0 : _a.rosterSettings) == null ? void 0 : _b.lineupSlotCounts;
  if (!counts) throw new AdapterError("ESPN_INVALID_RESPONSE", "ESPN did not return roster settings.");
  const { slots, rosterSize, skipped } = espnLineupSlots(counts);
  if (skipped.length) warnings.push(`Ignored unsupported ESPN lineup slots: ${skipped.join(", ")}.`);
  const memberName = new Map((payload.members ?? []).map((m) => [m.id, m.displayName || [m.firstName, m.lastName].filter(Boolean).join(" ")]));
  const teams = (payload.teams ?? []).map((t) => {
    var _a2, _b2;
    const entries = ((_a2 = t.roster) == null ? void 0 : _a2.entries) ?? [];
    const players = [];
    for (const e of entries) {
      if (e.lineupSlotId === ESPN_IR_SLOT) continue;
      const rp = espnRawPlayer((_b2 = e.playerPoolEntry) == null ? void 0 : _b2.player, e.playerId);
      if (rp) players.push(rp);
    }
    return {
      id: String(t.id),
      name: espnTeamName(t),
      ownerName: t.primaryOwner ? memberName.get(t.primaryOwner) : void 0,
      players
    };
  });
  if (!teams.length) throw new AdapterError("ESPN_INVALID_RESPONSE", "ESPN returned no teams (is this league visible to your account?).");
  const week = Math.max(1, payload.scoringPeriodId || ((_c = payload.status) == null ? void 0 : _c.currentMatchupPeriod) || 1);
  const settings = {
    platform: "espn",
    leagueId,
    leagueName: ((_d = payload.settings) == null ? void 0 : _d.name) ?? `ESPN league ${leagueId}`,
    season: payload.seasonId,
    week,
    teamCount: ((_e = payload.settings) == null ? void 0 : _e.size) ?? teams.length,
    rosterSize,
    scoring: espnScoring((_g = (_f = payload.settings) == null ? void 0 : _f.scoringSettings) == null ? void 0 : _g.scoringItems),
    lineupSlots: slots
  };
  return { settings, teams, warnings };
}
function normalizeEspnPlayerPool(payload) {
  const out = [];
  for (const entry of payload.players ?? []) {
    if (entry.onTeamId && entry.onTeamId !== 0) continue;
    const rp = espnRawPlayer(entry.player, entry.id);
    if (rp && OFFENSE_POSITIONS.includes(rp.position)) out.push(rp);
  }
  return out;
}
function espnTeamForSwid(payload, swid) {
  if (!swid) return null;
  const norm = swid.trim().toUpperCase();
  const t = (payload.teams ?? []).find((team) => (team.owners ?? []).some((o) => o.toUpperCase() === norm));
  return t ? String(t.id) : null;
}
const DEFAULT_SETTINGS = {
  manualTeamIds: {},
  projectionUrl: "",
  tradeValueUrl: "",
  projectionJson: "",
  tradeValueJson: "",
  config: {},
  scoringOverride: null
};
const KEY$1 = "oddsvisTradeOptimizerSettings";
let memory$1 = { ...DEFAULT_SETTINGS };
function hasChromeStorage() {
  var _a;
  return typeof chrome !== "undefined" && !!((_a = chrome.storage) == null ? void 0 : _a.sync);
}
async function loadSettings() {
  let stored;
  try {
    if (hasChromeStorage()) {
      stored = (await chrome.storage.sync.get(KEY$1))[KEY$1];
    } else if (typeof localStorage !== "undefined") {
      const raw = localStorage.getItem(KEY$1);
      stored = raw ? JSON.parse(raw) : void 0;
    } else {
      return memory$1;
    }
  } catch {
    return memory$1;
  }
  return { ...DEFAULT_SETTINGS, ...stored ?? {}, config: { ...(stored == null ? void 0 : stored.config) ?? {} } };
}
async function saveSettings(settings) {
  memory$1 = settings;
  try {
    if (hasChromeStorage()) await chrome.storage.sync.set({ [KEY$1]: settings });
    else if (typeof localStorage !== "undefined") localStorage.setItem(KEY$1, JSON.stringify(settings));
  } catch {
  }
}
const SLOT_BY_POSITION = {
  QB: SLOT_PRESETS.QB,
  RB: SLOT_PRESETS.RB,
  WR: SLOT_PRESETS.WR,
  TE: SLOT_PRESETS.TE,
  FLEX: SLOT_PRESETS.FLEX,
  SUPER_FLEX: SLOT_PRESETS.SUPERFLEX,
  REC_FLEX: SLOT_PRESETS["WR/TE"],
  WRRB_FLEX: SLOT_PRESETS["RB/WR"],
  K: SLOT_PRESETS.K,
  DEF: SLOT_PRESETS.DST
};
const NON_ROSTER = /* @__PURE__ */ new Set(["IR", "TAXI"]);
function sleeperLineupSlots(positions) {
  const counts = /* @__PURE__ */ new Map();
  const skipped = [];
  let rosterSize = 0;
  for (const p of positions) {
    if (NON_ROSTER.has(p)) continue;
    if (p === "BN") {
      rosterSize++;
      continue;
    }
    if (!(p in SLOT_BY_POSITION) || SLOT_BY_POSITION[p] === null) {
      if (!skipped.includes(p)) skipped.push(p);
      continue;
    }
    rosterSize++;
    counts.set(p, (counts.get(p) ?? 0) + 1);
  }
  const slots = [];
  for (const [p, count] of counts) slots.push({ ...SLOT_BY_POSITION[p], count });
  return { slots, rosterSize, skipped };
}
function trimSleeperPlayers(raw) {
  const out = {};
  for (const [id, p] of Object.entries(raw)) {
    if (!p || !p.position && !Array.isArray(p.fantasy_positions)) continue;
    const name = p.full_name || [p.first_name, p.last_name].filter(Boolean).join(" ");
    if (!name) continue;
    out[id] = [name, p.position || void 0, p.team || void 0];
  }
  return out;
}
function normalizeSleeperLeague(args) {
  var _a, _b;
  const { leagueId, league, rosters, users, players, state } = args;
  const warnings = [];
  if (!Array.isArray(league.roster_positions) || !Array.isArray(rosters)) {
    throw new AdapterError("SLEEPER_INVALID_RESPONSE", "Sleeper returned data in an unexpected shape.");
  }
  const { slots, rosterSize, skipped } = sleeperLineupSlots(league.roster_positions);
  if (skipped.length) warnings.push(`Ignored unsupported Sleeper roster positions: ${skipped.join(", ")}.`);
  const usersById = new Map(users.map((u) => [u.user_id, u]));
  const teams = rosters.map((r) => {
    var _a2, _b2;
    const user = r.owner_id ? usersById.get(r.owner_id) : void 0;
    const excluded = /* @__PURE__ */ new Set([...r.reserve ?? [], ...r.taxi ?? []]);
    const out = [];
    for (const id of r.players ?? []) {
      if (!id || id === "0" || excluded.has(id)) continue;
      const meta = players[id];
      const position = normalizePosition(meta == null ? void 0 : meta[1]);
      if (!position) continue;
      out.push({ platformId: id, name: meta ? meta[0] : `Player ${id}`, position, nflTeam: meta == null ? void 0 : meta[2] });
    }
    return {
      id: String(r.roster_id),
      name: ((_b2 = (_a2 = user == null ? void 0 : user.metadata) == null ? void 0 : _a2.team_name) == null ? void 0 : _b2.trim()) || (user == null ? void 0 : user.display_name) || `Team ${r.roster_id}`,
      ownerName: user == null ? void 0 : user.display_name,
      players: out
    };
  });
  const weekCandidates = [state == null ? void 0 : state.leg, state == null ? void 0 : state.display_week, state == null ? void 0 : state.week];
  const week = weekCandidates.find((w) => Number.isInteger(w) && w > 0) ?? 1;
  const settings = {
    platform: "sleeper",
    leagueId,
    leagueName: league.name ?? `Sleeper league ${leagueId}`,
    season: Number(league.season) || Number(state == null ? void 0 : state.season) || (/* @__PURE__ */ new Date()).getFullYear(),
    week,
    teamCount: league.total_rosters ?? teams.length,
    rosterSize,
    scoring: {
      receptionPoints: ((_a = league.scoring_settings) == null ? void 0 : _a.rec) ?? 0,
      passTdPoints: ((_b = league.scoring_settings) == null ? void 0 : _b.pass_td) ?? 4
    },
    lineupSlots: slots
  };
  return { settings, teams, warnings };
}
const EMPTY_LICENSE = {
  key: null,
  status: "none",
  validatedAt: null,
  expiresAt: null,
  instanceId: null,
  email: null,
  message: null
};
const DAY = 24 * 60 * 60 * 1e3;
function isEntitled(state, config, now = Date.now()) {
  if (config.provider === "none") return true;
  if (state.status !== "active" || !state.validatedAt) return false;
  if (state.expiresAt && Date.parse(state.expiresAt) < now) return false;
  return now - state.validatedAt <= config.graceDays * DAY;
}
function needsRevalidation(state, config, now = Date.now()) {
  if (config.provider === "none" || !state.key) return false;
  if (!state.validatedAt) return true;
  return now - state.validatedAt > config.revalidateHours * 60 * 60 * 1e3;
}
function applyResult(previous, key, result, now = Date.now()) {
  if (result.networkError) {
    return { ...previous, key, message: result.message ?? "Could not reach the license server; using the last known status." };
  }
  if (!result.valid) {
    const expired = result.expiresAt ? Date.parse(result.expiresAt) < now : false;
    return {
      ...previous,
      key,
      status: expired ? "expired" : "invalid",
      validatedAt: previous.status === "active" ? previous.validatedAt : null,
      expiresAt: result.expiresAt ?? previous.expiresAt,
      message: result.message ?? (expired ? "This license has expired." : "This license key is not valid.")
    };
  }
  return {
    key,
    status: "active",
    validatedAt: now,
    expiresAt: result.expiresAt ?? null,
    instanceId: result.instanceId ?? previous.instanceId ?? null,
    email: result.email ?? previous.email ?? null,
    message: null
  };
}
async function activateLicense(key, validator, instanceName2, now = Date.now()) {
  const trimmed = key.trim();
  if (!trimmed) return { ...EMPTY_LICENSE, message: "Enter a license key." };
  const result = await validator.activate(trimmed, instanceName2);
  if (result.networkError) {
    return { ...EMPTY_LICENSE, message: result.message ?? "Could not reach the license server. Check your connection and try again." };
  }
  return applyResult(EMPTY_LICENSE, trimmed, result, now);
}
async function refreshLicense(state, validator, config, now = Date.now()) {
  if (!state.key || !needsRevalidation(state, config, now)) return state;
  const result = await validator.validate(state.key, state.instanceId);
  return applyResult(state, state.key, result, now);
}
class LemonSqueezyValidator {
  constructor(base = "https://api.lemonsqueezy.com/v1/licenses", fetchFn = fetch) {
    this.base = base;
    this.fetchFn = fetchFn;
  }
  async post(path, body) {
    var _a, _b, _c, _d;
    let res;
    try {
      res = await this.fetchFn(`${this.base}/${path}`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
    } catch {
      return { valid: false, networkError: true };
    }
    let data = null;
    try {
      data = await res.json();
    } catch {
      return { valid: false, networkError: true, message: `Unexpected response (${res.status}).` };
    }
    const ok = path === "activate" ? (data == null ? void 0 : data.activated) === true : (data == null ? void 0 : data.valid) === true;
    const status = (_a = data == null ? void 0 : data.license_key) == null ? void 0 : _a.status;
    return {
      valid: ok && (status === void 0 || status === "active"),
      expiresAt: ((_b = data == null ? void 0 : data.license_key) == null ? void 0 : _b.expires_at) ?? null,
      instanceId: ((_c = data == null ? void 0 : data.instance) == null ? void 0 : _c.id) ?? null,
      email: ((_d = data == null ? void 0 : data.meta) == null ? void 0 : _d.customer_email) ?? null,
      message: (data == null ? void 0 : data.error) ?? (status && status !== "active" ? `License is ${status}.` : null)
    };
  }
  activate(key, instanceName2) {
    return this.post("activate", { license_key: key, instance_name: instanceName2 });
  }
  validate(key, instanceId) {
    return this.post("validate", instanceId ? { license_key: key, instance_id: instanceId } : { license_key: key });
  }
}
class RemoteValidator {
  constructor(url, fetchFn = fetch) {
    this.url = url;
    this.fetchFn = fetchFn;
  }
  async post(body) {
    if (!this.url) return { valid: false, message: "License server is not configured (VITE_PAYWALL_VALIDATE)." };
    try {
      const res = await this.fetchFn(this.url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
      const data = await res.json();
      return { ...data, valid: data.valid === true };
    } catch {
      return { valid: false, networkError: true };
    }
  }
  activate(key, instanceName2) {
    return this.post({ key, instanceName: instanceName2 });
  }
  validate(key, instanceId) {
    return this.post({ key, instanceId });
  }
}
class SignedKeyValidator {
  constructor(publicKey, now = Date.now) {
    this.publicKey = publicKey;
    this.now = now;
  }
  async check(key) {
    if (!this.publicKey) return { valid: false, message: "License verification is not configured (VITE_PAYWALL_PUBLIC_KEY)." };
    const [payload, signature, ...rest] = key.replace(/\s+/g, "").split(".");
    if (!payload || !signature || rest.length) return { valid: false };
    let claims;
    try {
      const publicKey = await crypto.subtle.importKey("raw", fromBase64Url(this.publicKey), { name: "ECDSA", namedCurve: "P-256" }, false, ["verify"]);
      const ok = await crypto.subtle.verify({ name: "ECDSA", hash: "SHA-256" }, publicKey, fromBase64Url(signature), new TextEncoder().encode(payload));
      if (!ok) return { valid: false };
      claims = JSON.parse(new TextDecoder().decode(fromBase64Url(payload)));
    } catch {
      return { valid: false };
    }
    const expiresAt = claims.exp ?? null;
    const live = expiresAt === null || Date.parse(expiresAt) >= this.now();
    return { valid: live, expiresAt, email: claims.email ?? null };
  }
  activate(key) {
    return this.check(key);
  }
  validate(key) {
    return this.check(key);
  }
}
function fromBase64Url(text) {
  const binary = atob(text.replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(binary, (c) => c.charCodeAt(0));
}
class AlwaysValidValidator {
  async activate() {
    return { valid: true };
  }
  async validate() {
    return { valid: true };
  }
}
function validatorFor(config) {
  switch (config.provider) {
    case "lemonsqueezy":
      return new LemonSqueezyValidator();
    case "remote":
      return new RemoteValidator(config.validateUrl);
    case "signed":
      return new SignedKeyValidator(config.publicKey);
    default:
      return new AlwaysValidValidator();
  }
}
const KEY = "oddsvisTradeOptimizerLicense";
let memory = EMPTY_LICENSE;
async function loadLicense() {
  var _a;
  try {
    if (typeof chrome !== "undefined" && ((_a = chrome.storage) == null ? void 0 : _a.sync)) {
      const raw = await chrome.storage.sync.get(KEY);
      const stored = raw[KEY];
      return { ...EMPTY_LICENSE, ...stored ?? {} };
    }
    if (typeof localStorage !== "undefined") {
      const raw = localStorage.getItem(KEY);
      if (raw) return { ...EMPTY_LICENSE, ...JSON.parse(raw) };
    }
  } catch {
  }
  return memory;
}
async function saveLicense(state) {
  var _a;
  memory = state;
  try {
    if (typeof chrome !== "undefined" && ((_a = chrome.storage) == null ? void 0 : _a.sync)) await chrome.storage.sync.set({ [KEY]: state });
    else if (typeof localStorage !== "undefined") localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
  }
}
function instanceName() {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : "Browser";
  const os = /Mac/.test(ua) ? "macOS" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  return `${browser} ${os}`.trim() || "extension";
}
const __vite_import_meta_env__ = { "BASE_URL": "/", "DEV": false, "MODE": "production", "PROD": true, "SSR": false, "VITE_PAYWALL_CHECKOUT_LIFETIME": "https://www.paypal.com/ncp/payment/3XKKHF4XVSHWU", "VITE_PAYWALL_CHECKOUT_MONTHLY": "https://www.paypal.com/ncp/payment/AEVAXGZFK2BLC", "VITE_PAYWALL_CHECKOUT_SEASON": "https://www.paypal.com/ncp/payment/ZJAH92CFHJHGS", "VITE_PAYWALL_CHECKOUT_WEEKEND": "https://www.paypal.com/ncp/payment/K3C5YSQRPMB7E", "VITE_PAYWALL_DEFAULT_PLAN": "monthly", "VITE_PAYWALL_FREE_RANKS": "1", "VITE_PAYWALL_PRICE_LIFETIME": "$49.99", "VITE_PAYWALL_PRICE_MONTHLY": "$6.99", "VITE_PAYWALL_PRICE_SEASON": "$24.99", "VITE_PAYWALL_PRICE_WEEKEND": "$1", "VITE_PAYWALL_PRODUCT": "VegasLytics Trade Optimizer Pro", "VITE_PAYWALL_PROVIDER": "signed", "VITE_PAYWALL_PUBLIC_KEY": "BPbY-eL809qpzHAKo10itTu0ck8IBd8e1ydis3XoXTZpotsEGbZvgMDX7sheq3PlIeWlNy-445Fwow4nnkEAv08", "VITE_PAYWALL_STORE": "", "VITE_PAYWALL_VALIDATE": "", "VITE_PAYWALL_VARIANT_LIFETIME": "2171612", "VITE_PAYWALL_VARIANT_MONTHLY": "2171604", "VITE_PAYWALL_VARIANT_SEASON": "2171607", "VITE_PAYWALL_VARIANT_WEEKEND": "2171618" };
const PLAN_META = [
  { id: "weekend", label: "Weekend pass", description: "Every trade for one slate. Good through Monday night." },
  { id: "monthly", label: "Monthly", description: "Renews monthly. Cancel any time." },
  { id: "season", label: "Season pass", description: "Every week through the fantasy playoffs." },
  { id: "lifetime", label: "Lifetime", description: "Pay once, every season." }
];
function buildPaywallConfig(env2) {
  const providerRaw = (env2.VITE_PAYWALL_PROVIDER ?? "lemonsqueezy").toLowerCase();
  const provider = providerRaw === "none" || providerRaw === "remote" || providerRaw === "signed" || providerRaw === "lemonsqueezy" ? providerRaw : "lemonsqueezy";
  const store = (env2.VITE_PAYWALL_STORE ?? "").trim();
  const single = (env2.VITE_PAYWALL_CHECKOUT ?? "").trim();
  const plans = [];
  for (const meta of PLAN_META) {
    const key = meta.id.toUpperCase();
    const variantId = (env2[`VITE_PAYWALL_VARIANT_${key}`] ?? "").trim();
    const override = (env2[`VITE_PAYWALL_CHECKOUT_${key}`] ?? "").trim();
    const checkoutUrl = single || override || (store && variantId ? `https://${store}.lemonsqueezy.com/checkout/buy/${variantId}` : "");
    if (!checkoutUrl) continue;
    const description = provider === "signed" && meta.id === "monthly" ? "Every trade for 30 days. No auto-renewal." : meta.description;
    plans.push({ ...meta, description, variantId, checkoutUrl, priceLabel: (env2[`VITE_PAYWALL_PRICE_${key}`] ?? "").trim() });
  }
  const wanted = (env2.VITE_PAYWALL_DEFAULT_PLAN ?? "season").toLowerCase();
  const defaultPlan = plans.find((p) => p.id === wanted) ?? plans[0] ?? null;
  return {
    provider,
    productName: env2.VITE_PAYWALL_PRODUCT ?? "VegasLytics Trade Optimizer Pro",
    plans,
    defaultPlan,
    checkoutUrl: (defaultPlan == null ? void 0 : defaultPlan.checkoutUrl) ?? "",
    singleCheckout: single !== "",
    priceLabel: (defaultPlan == null ? void 0 : defaultPlan.priceLabel) ? `from ${cheapest(plans)}` : "",
    validateUrl: env2.VITE_PAYWALL_VALIDATE ?? "",
    publicKey: (env2.VITE_PAYWALL_PUBLIC_KEY ?? "").trim(),
    freeRanks: parseFreeRanks(env2),
    graceDays: 7,
    revalidateHours: 24
  };
}
function parseFreeRanks(env2) {
  const explicit = (env2.VITE_PAYWALL_FREE_RANKS ?? "").split(",").map((x) => Number(x.trim())).filter((n) => Number.isInteger(n) && n >= 1);
  if (explicit.length) return [...new Set(explicit)].sort((a, b) => a - b);
  const legacy = Number(env2.VITE_PAYWALL_FREE_TRADES);
  if (Number.isInteger(legacy) && legacy >= 0) return Array.from({ length: legacy }, (_, i) => i + 1);
  return [1];
}
function cheapest(plans) {
  var _a;
  const priced = plans.map((p) => ({ p, n: Number(p.priceLabel.replace(/[^0-9.]/g, "")) })).filter((x) => Number.isFinite(x.n) && x.n > 0).sort((a, b) => a.n - b.n);
  return ((_a = priced[0]) == null ? void 0 : _a.p.priceLabel) ?? "";
}
const env = __vite_import_meta_env__ ?? {};
const PAYWALL_CONFIG = buildPaywallConfig(env);
const fmt1 = (n) => n.toFixed(1);
const signed1 = (n) => `${n >= 0 ? "+" : ""}${n.toFixed(1)}`;
const money = (n) => `$${Math.round(n)}`;
const ordinal = (n) => {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  const suffix = { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th";
  return `${n}${suffix}`;
};
const posClass = (position) => `pos pos-${position.toLowerCase()}`;
function PlayerChip({ player, marginal, showValue = true }) {
  const est = player.tradeValueSource === "estimated";
  return /* @__PURE__ */ jsxs("span", { className: "player", children: [
    /* @__PURE__ */ jsx("span", { className: posClass(player.position), children: player.position }),
    /* @__PURE__ */ jsx("span", { className: "player-name", title: player.nflTeam ? `${player.name} · ${player.nflTeam}` : player.name, children: player.name }),
    player.projectionStale ? /* @__PURE__ */ jsx("span", { className: "tag tag-warn", title: "Missing a required prop in the latest odds; the projection uses the last posted value. Left out of trades.", children: "props incomplete" }) : null,
    showValue ? /* @__PURE__ */ jsxs("span", { className: "player-meta", children: [
      /* @__PURE__ */ jsxs("span", { className: "num", title: est ? "Estimated: not in the trade value dataset" : "Trade value", children: [
        est ? "~" : "",
        money(player.tradeValue)
      ] }),
      /* @__PURE__ */ jsx("span", { className: "sep", children: "·" }),
      /* @__PURE__ */ jsx("span", { className: "num", title: player.projectionSource === "estimated" ? "No props posted yet: estimated from trade value" : "Median projection this week", children: player.projectionSource === "dataset" ? fmt1(player.projection) : player.projectionSource === "estimated" ? `~${fmt1(player.projection)}` : "—" }),
      marginal !== void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "sep", children: "·" }),
        /* @__PURE__ */ jsxs("span", { className: "num muted", title: "Marginal starting-lineup value", children: [
          "mv ",
          fmt1(marginal)
        ] })
      ] }) : null
    ] }) : null
  ] });
}
function LineupTable({ lineup, highlight, title }) {
  return /* @__PURE__ */ jsxs("div", { className: "table-wrap", children: [
    title ? /* @__PURE__ */ jsx("div", { className: "table-title", children: title }) : null,
    /* @__PURE__ */ jsx("table", { className: "lineup", children: /* @__PURE__ */ jsxs("tbody", { children: [
      lineup.assignments.map((a, i) => {
        var _a;
        return /* @__PURE__ */ jsxs("tr", { className: a.player && (highlight == null ? void 0 : highlight.has(a.player.id)) ? "hl" : void 0, children: [
          /* @__PURE__ */ jsx("td", { className: "slot", children: a.slot.key }),
          /* @__PURE__ */ jsx("td", { children: a.player ? /* @__PURE__ */ jsxs("span", { className: "player", children: [
            /* @__PURE__ */ jsx("span", { className: posClass(a.player.position), children: a.player.position }),
            /* @__PURE__ */ jsx("span", { className: "player-name", children: a.player.name })
          ] }) : /* @__PURE__ */ jsx("span", { className: "muted", children: "empty" }) }),
          /* @__PURE__ */ jsxs("td", { className: "num right", children: [
            ((_a = a.player) == null ? void 0 : _a.projectionSource) === "estimated" ? "~" : "",
            fmt1(a.projection)
          ] })
        ] }, i);
      }),
      /* @__PURE__ */ jsxs("tr", { className: "total", children: [
        /* @__PURE__ */ jsx("td", { colSpan: 2, children: "Total" }),
        /* @__PURE__ */ jsx("td", { className: "num right", children: fmt1(lineup.total) })
      ] })
    ] }) })
  ] });
}
function ExpandToggle({ open, more = "More details" }) {
  return /* @__PURE__ */ jsxs("button", { type: "button", className: "expand-toggle", "aria-expanded": open, children: [
    open ? "Less" : more,
    /* @__PURE__ */ jsx("svg", { className: "expand-chevron", viewBox: "0 0 16 16", width: "14", height: "14", "aria-hidden": "true", children: /* @__PURE__ */ jsx("path", { d: "M3.5 6l4.5 4.5L12.5 6", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })
  ] });
}
function TeamAnalysisPanel({ analysis, team }) {
  const [open, setOpen] = useState(false);
  const [showLineup, setShowLineup] = useState(false);
  const adviceMoves = team.waiverMoves.filter((m) => m.gain >= 0.5);
  const weaknesses = team.weaknesses.filter((w) => OFFENSE_POSITIONS.some((p) => w.eligible.includes(p)));
  const surplusAssets = team.positionalSurplus.flatMap((s) => s.expendable.map((e) => ({ ...e, position: s.position, level: s.level }))).filter((e) => OFFENSE_POSITIONS.includes(e.position) && e.player.tradeValue > 0).sort((a, b) => b.player.tradeValue - a.player.tradeValue).slice(0, 8);
  return /* @__PURE__ */ jsxs("section", { className: "panel", children: [
    /* @__PURE__ */ jsxs("div", { className: "panel-head clickable", onClick: () => setOpen((v) => !v), children: [
      /* @__PURE__ */ jsxs("h2", { children: [
        "Team analysis · ",
        team.teamName
      ] }),
      /* @__PURE__ */ jsx(ExpandToggle, { open, more: "Full analysis" })
    ] }),
    open ? /* @__PURE__ */ jsxs("div", { className: "chips", children: [
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        "Optimal lineup ",
        /* @__PURE__ */ jsx("b", { children: fmt1(team.optimalStartingProjection) })
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        "Lineup rank ",
        /* @__PURE__ */ jsx("b", { children: ordinal(team.projectionRank) })
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        "Trade value ",
        /* @__PURE__ */ jsx("b", { children: money(team.totalTradeValue) }),
        " (",
        ordinal(team.tradeValueRank),
        ")"
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        "Bench value ",
        /* @__PURE__ */ jsx("b", { children: money(team.benchTradeValue) })
      ] })
    ] }) : null,
    open && analysis.insight.length ? /* @__PURE__ */ jsx("div", { className: "insight", children: analysis.insight.map((line, i) => /* @__PURE__ */ jsx("p", { children: line }, i)) }) : null,
    open && adviceMoves.length ? /* @__PURE__ */ jsxs("div", { className: "note warn", children: [
      /* @__PURE__ */ jsx("b", { children: "Do this first (free):" }),
      " ",
      adviceMoves.map((m, i) => /* @__PURE__ */ jsxs("span", { children: [
        i > 0 ? "; " : "",
        "add ",
        m.add.name,
        " (",
        fmt1(m.add.projection),
        ")",
        m.drop ? ` and drop ${m.drop.name} (${fmt1(m.drop.projection)})` : " to an open roster spot",
        " for +",
        fmt1(m.gain)
      ] }, i)),
      ". Trades below are measured after these moves."
    ] }) : null,
    open ? /* @__PURE__ */ jsxs("button", { className: "text-btn", onClick: () => setShowLineup((v) => !v), children: [
      showLineup ? "Hide" : "Show",
      " optimal lineup"
    ] }) : null,
    open && showLineup ? /* @__PURE__ */ jsx(LineupTable, { lineup: team.optimal }) : null,
    /* @__PURE__ */ jsx("h3", { children: "Largest weaknesses" }),
    /* @__PURE__ */ jsx("ol", { className: "weakness-list", children: weaknesses.slice(0, 4).map((w) => /* @__PURE__ */ jsxs("li", { children: [
      /* @__PURE__ */ jsxs("div", { className: "weakness-head", children: [
        /* @__PURE__ */ jsx("b", { children: w.key }),
        w.isHole ? /* @__PURE__ */ jsx("span", { className: "tag tag-warn", children: "roster hole" }) : null,
        /* @__PURE__ */ jsxs("span", { className: "muted", children: [
          "league rank ",
          ordinal(w.leagueRank),
          " of ",
          analysis.teams.length
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "weakness-body", children: [
        /* @__PURE__ */ jsxs("div", { children: [
          "Current: ",
          /* @__PURE__ */ jsx("span", { className: "num", children: w.starter ? `${w.starter.name} · ${fmt1(w.projection)}` : "empty" })
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "Replacement level: ",
          /* @__PURE__ */ jsx("span", { className: "num", children: fmt1(w.replacementProjection) }),
          /* @__PURE__ */ jsx("span", { className: "sep", children: "·" }),
          "League median: ",
          /* @__PURE__ */ jsx("span", { className: "num", children: fmt1(w.leagueMedian) })
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "Potential upgrade range: ",
          /* @__PURE__ */ jsxs("span", { className: "num", children: [
            signed1(w.upgradeRange.low),
            " to ",
            signed1(w.upgradeRange.high)
          ] }),
          w.upgradeTargets[0] ? /* @__PURE__ */ jsxs("span", { className: "muted", children: [
            " (best realistic target: ",
            w.upgradeTargets[0].player.name,
            ", ",
            fmt1(w.upgradeTargets[0].player.projection),
            ")"
          ] }) : null
        ] })
      ] })
    ] }, w.key)) }),
    open ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("h3", { children: "Surplus / expendable assets" }),
      surplusAssets.length === 0 ? /* @__PURE__ */ jsx("p", { className: "muted", children: "No expendable players with trade value: every valued player is in your optimal lineup." }) : /* @__PURE__ */ jsx("ul", { className: "asset-list", children: surplusAssets.map((a) => /* @__PURE__ */ jsxs("li", { children: [
        /* @__PURE__ */ jsx(PlayerChip, { player: a.player, marginal: a.marginal }),
        /* @__PURE__ */ jsxs("span", { className: "muted", children: [
          " ",
          a.position,
          " surplus: ",
          a.level
        ] })
      ] }, a.player.id)) }),
      /* @__PURE__ */ jsx("h3", { children: "Positional surplus" }),
      /* @__PURE__ */ jsx("div", { className: "surplus-grid", children: team.positionalSurplus.filter((s) => OFFENSE_POSITIONS.includes(s.position)).map((s) => /* @__PURE__ */ jsxs("div", { className: `surplus-cell level-${s.level.replace(" ", "-")}`, children: [
        /* @__PURE__ */ jsx("div", { className: "surplus-pos", children: s.position }),
        /* @__PURE__ */ jsx("div", { className: "surplus-level", children: s.level }),
        /* @__PURE__ */ jsxs("div", { className: "muted small", children: [
          fmt1(s.trappedProjection),
          " bench pts > repl"
        ] })
      ] }, s.position)) })
    ] }) : null
  ] });
}
const isNumeric = (v) => !!v && /^\d+$/.test(v);
function espnTradeUrl(league, partnerTeamId, userReceives) {
  const { leagueId, season } = league.settings;
  if (!isNumeric(leagueId) || !isNumeric(league.userTeamId) || !isNumeric(partnerTeamId)) return null;
  const players = userReceives.map((p) => p.platformId).filter(isNumeric);
  return `https://fantasy.espn.com/football/team/trade?leagueId=${leagueId}&seasonId=${season}&teamId=${partnerTeamId}&fromTeamId=${league.userTeamId}&step=1${players.length ? `&players=${players.join(",")}` : ""}`;
}
function tradeScreenLink(league, trade, partnerName) {
  switch (league.settings.platform) {
    case "espn": {
      const url = espnTradeUrl(league, trade.partnerTeamId, trade.userReceives);
      if (!url) return null;
      return { url, label: "Open in ESPN", hint: "Opens ESPN's trade screen with the players you receive selected. Tick the players you send there." };
    }
    case "sleeper": {
      if (!isNumeric(league.settings.leagueId)) return null;
      return {
        url: `https://sleeper.com/leagues/${league.settings.leagueId}/trades`,
        label: "Open Sleeper trade center",
        hint: `Sleeper can't pre-fill a trade: pick ${partnerName} and these players there.`
      };
    }
    default:
      return null;
  }
}
function TradeScreenLink({ league, trade, partnerName }) {
  const link = tradeScreenLink(league, trade, partnerName);
  if (!link) return null;
  return /* @__PURE__ */ jsxs("div", { className: "trade-actions", children: [
    /* @__PURE__ */ jsxs("a", { className: "site-link", href: link.url, target: "_blank", rel: "noopener noreferrer", children: [
      link.label,
      /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", width: "12", height: "12", "aria-hidden": "true", children: /* @__PURE__ */ jsx("path", { d: "M6 3h7v7M13 3L4 12", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })
    ] }),
    /* @__PURE__ */ jsx("span", { className: "muted small", children: link.hint })
  ] });
}
function TradeCard({ trade, analysis }) {
  const [open, setOpen] = useState(false);
  const [showLineups, setShowLineups] = useState(false);
  const sim = trade.simulation;
  const opp = analysis.teams.find((t) => t.teamId === sim.candidate.partnerTeamId);
  const user = analysis.user;
  const incomingIds = new Set(sim.candidate.userReceives.map((p) => p.id));
  const outgoingIds = new Set(sim.candidate.userSends.map((p) => p.id));
  return /* @__PURE__ */ jsxs("article", { className: "panel trade", children: [
    /* @__PURE__ */ jsxs("header", { className: "trade-head", onClick: () => setOpen((v) => !v), children: [
      /* @__PURE__ */ jsxs("div", { className: "trade-rank", children: [
        "#",
        trade.rank
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "trade-summary", children: [
        /* @__PURE__ */ jsxs("div", { className: "trade-title", children: [
          "Trade with ",
          /* @__PURE__ */ jsx("b", { children: opp.teamName }),
          /* @__PURE__ */ jsx("span", { className: `tag tier tier-${trade.score.tier}`, children: TIER_LABEL[trade.score.tier] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "trade-gains", children: [
          /* @__PURE__ */ jsxs("span", { className: "gain you", children: [
            "You ",
            signed1(sim.user.projectionGain)
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "gain them", children: [
            "They ",
            signed1(sim.opponent.projectionGain)
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "muted", children: [
            money(sim.user.tradeValueSent),
            " ↔ ",
            money(sim.user.tradeValueReceived)
          ] })
        ] }),
        sim.user.solvedWeaknesses.length || sim.opponent.solvedWeaknesses.length ? /* @__PURE__ */ jsxs("div", { className: "muted small", children: [
          "Solves",
          sim.user.solvedWeaknesses.length ? ` your ${sim.user.solvedWeaknesses.join(", ")}` : "",
          sim.user.solvedWeaknesses.length && sim.opponent.solvedWeaknesses.length ? " and" : "",
          sim.opponent.solvedWeaknesses.length ? ` their ${sim.opponent.solvedWeaknesses.join(", ")}` : ""
        ] }) : null
      ] }),
      /* @__PURE__ */ jsx(ExpandToggle, { open })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "trade-sides", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "side-label", children: "You send" }),
        /* @__PURE__ */ jsx("ul", { children: sim.candidate.userSends.map((p) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(PlayerChip, { player: p, marginal: user.playerMarginalValues[p.id] ?? 0 }) }, p.id)) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "side-label", children: "You receive" }),
        /* @__PURE__ */ jsx("ul", { children: sim.candidate.userReceives.map((p) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(PlayerChip, { player: p, marginal: opp.playerMarginalValues[p.id] ?? 0 }) }, p.id)) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(TradeScreenLink, { league: analysis.originalLeague, trade: sim.candidate, partnerName: opp.teamName }),
    open ? /* @__PURE__ */ jsxs("div", { className: "trade-detail", children: [
      /* @__PURE__ */ jsxs("div", { className: "metrics", children: [
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Your lineup" }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            fmt1(sim.user.projectionBefore),
            " → ",
            fmt1(sim.user.projectionAfter)
          ] }),
          /* @__PURE__ */ jsx("div", { className: `num gain ${sim.user.projectionGain >= 0 ? "pos" : "neg"}`, children: signed1(sim.user.projectionGain) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: opp.teamName }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            fmt1(sim.opponent.projectionBefore),
            " → ",
            fmt1(sim.opponent.projectionAfter)
          ] }),
          /* @__PURE__ */ jsx("div", { className: `num gain ${sim.opponent.projectionGain >= 0 ? "pos" : "neg"}`, children: signed1(sim.opponent.projectionGain) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Trade value" }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            "send ",
            money(sim.user.tradeValueSent),
            " · get ",
            money(sim.user.tradeValueReceived)
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "muted", children: [
            "fairness ",
            (trade.acceptance.fairnessRatio * 100).toFixed(0),
            "%"
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Holes (you)" }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            sim.user.holesBefore,
            " → ",
            sim.user.holesAfter
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "muted", children: [
            "depth ",
            signed1(sim.user.depthAfter - sim.user.depthBefore)
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx("h4", { children: "Why it works" }),
      /* @__PURE__ */ jsxs("div", { className: "why", children: [
        /* @__PURE__ */ jsxs("div", { className: "why-col", children: [
          /* @__PURE__ */ jsx("div", { className: "why-title", children: "Your side" }),
          /* @__PURE__ */ jsx("ul", { children: trade.explanation.userSide.map((l, i) => /* @__PURE__ */ jsx("li", { children: l }, i)) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "why-col", children: [
          /* @__PURE__ */ jsx("div", { className: "why-title", children: opp.teamName }),
          /* @__PURE__ */ jsx("ul", { children: trade.explanation.opponentSide.map((l, i) => /* @__PURE__ */ jsx("li", { children: l }, i)) })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "why-overall", children: trade.explanation.overall.map((l, i) => /* @__PURE__ */ jsx("p", { children: l }, i)) }),
      /* @__PURE__ */ jsx("h4", { children: "Score breakdown" }),
      /* @__PURE__ */ jsxs("div", { className: "score-row", children: [
        /* @__PURE__ */ jsxs("span", { children: [
          "User gain ",
          /* @__PURE__ */ jsx("b", { className: "num", children: signed1(trade.score.userGain) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+ weakness fix ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.weaknessBonus.toFixed(2) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+ their weakness fix ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.opponentWeaknessBonus.toFixed(2) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+ mutual ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.mutualBonus.toFixed(2) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+ fairness ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.fairnessBonus.toFixed(2) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "+ depth ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.depthBonus.toFixed(2) })
        ] }),
        /* @__PURE__ */ jsxs("span", { children: [
          "= ",
          /* @__PURE__ */ jsx("b", { className: "num", children: trade.score.total.toFixed(2) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "muted small", children: [
        "Trades are grouped by tier first (win/win, then mutual gain, then fair one-sided). Inside a tier, secondary bonuses are capped at ",
        trade.score.band.toFixed(2),
        " points combined, so a trade that gains you more than that in starting-lineup points always ranks higher."
      ] }),
      trade.rankedAboveNextBecause ? /* @__PURE__ */ jsxs("p", { className: "muted small", children: [
        "Ranked above #",
        trade.rank + 1,
        " because it ",
        trade.rankedAboveNextBecause,
        "."
      ] }) : null,
      /* @__PURE__ */ jsxs("button", { className: "text-btn", onClick: () => setShowLineups((v) => !v), children: [
        showLineups ? "Hide" : "Show",
        " before/after lineups"
      ] }),
      showLineups ? /* @__PURE__ */ jsxs("div", { className: "lineups-grid", children: [
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.user.before, title: "You · before", highlight: outgoingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.user.after, title: "You · after", highlight: incomingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.opponent.before, title: `${opp.teamName} · before`, highlight: incomingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.opponent.after, title: `${opp.teamName} · after`, highlight: outgoingIds })
      ] }) : null
    ] }) : null
  ] });
}
function LockedTradeCard({ trade, analysis, onUpgrade, priceLabel }) {
  const sim = trade.simulation;
  const opp = analysis.teams.find((t) => t.teamId === sim.candidate.partnerTeamId);
  const sends = sim.candidate.userSends.length;
  const receives = sim.candidate.userReceives.length;
  return /* @__PURE__ */ jsxs("article", { className: "panel trade locked", children: [
    /* @__PURE__ */ jsxs("header", { className: "trade-head", children: [
      /* @__PURE__ */ jsxs("div", { className: "trade-rank", children: [
        "#",
        trade.rank
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "trade-summary", children: [
        /* @__PURE__ */ jsxs("div", { className: "trade-title", children: [
          "Trade with ",
          /* @__PURE__ */ jsx("b", { children: opp.teamName }),
          trade.score ? /* @__PURE__ */ jsx("span", { className: `tag tier tier-${trade.score.tier}`, children: TIER_LABEL[trade.score.tier] }) : /* @__PURE__ */ jsx("span", { className: "tag tier tier-unfair", children: "Unfair" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "trade-gains", children: [
          /* @__PURE__ */ jsxs("span", { className: "gain you", children: [
            "You ",
            signed1(sim.user.projectionGain)
          ] }),
          trade.valueGain !== void 0 ? /* @__PURE__ */ jsxs("span", { className: "gain value", children: [
            "+",
            money(trade.valueGain),
            " value"
          ] }) : null,
          /* @__PURE__ */ jsxs("span", { className: "gain them", children: [
            "They ",
            signed1(sim.opponent.projectionGain)
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "muted", children: [
            money(sim.user.tradeValueSent),
            " ↔ ",
            money(sim.user.tradeValueReceived)
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "lock", "aria-label": "Locked", children: "🔒" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "trade-sides", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: "side-label", children: [
          "You send (",
          sends,
          ")"
        ] }),
        /* @__PURE__ */ jsx("ul", { children: Array.from({ length: sends }).map((_, i) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("span", { className: "redacted" }) }, i)) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: "side-label", children: [
          "You receive (",
          receives,
          ")"
        ] }),
        /* @__PURE__ */ jsx("ul", { children: Array.from({ length: receives }).map((_, i) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("span", { className: "redacted" }) }, i)) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "locked-cta", children: [
      /* @__PURE__ */ jsxs("span", { children: [
        trade.rank === 1 ? "Your best trade: a" : "A",
        " ",
        sends,
        "-for-",
        receives,
        " with ",
        opp.teamName,
        " that adds ",
        /* @__PURE__ */ jsx("b", { children: signed1(sim.user.projectionGain) }),
        " to your starting lineup",
        sim.user.holesAfter < sim.user.holesBefore ? " and fills a roster hole" : "",
        "."
      ] }),
      /* @__PURE__ */ jsxs("button", { className: "primary", onClick: onUpgrade, children: [
        "Unlock all trades",
        priceLabel ? ` · ${priceLabel}` : ""
      ] })
    ] })
  ] });
}
function LeagueTable({ analysis, onPickTeam, picking = false }) {
  const rows = [...analysis.teams].sort((a, b) => a.projectionRank - b.projectionRank);
  const pickable = Boolean(onPickTeam) && picking;
  return /* @__PURE__ */ jsxs("section", { className: `panel${pickable ? " picking" : ""}`, children: [
    /* @__PURE__ */ jsxs("div", { className: "panel-head", children: [
      /* @__PURE__ */ jsx("h2", { children: pickable ? "Pick your team to continue" : "League overview" }),
      /* @__PURE__ */ jsx("span", { className: "muted small", children: pickable ? "Click your team, or its button, in the list below." : `Replacement level: ${OFFENSE_POSITIONS.map((p) => `${p} ${fmt1(analysis.replacement.levels[p])}`).join(" · ")}` })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "table-wrap", children: /* @__PURE__ */ jsxs("table", { className: "league", children: [
      /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { children: "#" }),
        /* @__PURE__ */ jsx("th", { children: "Team" }),
        /* @__PURE__ */ jsx("th", { className: "right", children: "Lineup" }),
        /* @__PURE__ */ jsx("th", { className: "right", children: "Value" }),
        /* @__PURE__ */ jsx("th", { children: "Holes" }),
        /* @__PURE__ */ jsx("th", { children: "Surplus" }),
        onPickTeam ? /* @__PURE__ */ jsx("th", {}) : null
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { children: rows.map((t) => /* @__PURE__ */ jsxs(
        "tr",
        {
          className: t.isUser ? "me" : pickable ? "pickable" : void 0,
          onClick: pickable ? () => onPickTeam == null ? void 0 : onPickTeam(t.teamId) : void 0,
          children: [
            /* @__PURE__ */ jsx("td", { className: "num", children: t.projectionRank }),
            /* @__PURE__ */ jsxs("td", { children: [
              t.teamName,
              t.isUser ? /* @__PURE__ */ jsx("span", { className: "tag", children: "you" }) : null
            ] }),
            /* @__PURE__ */ jsx("td", { className: "num right", children: fmt1(t.optimalStartingProjection) }),
            /* @__PURE__ */ jsx("td", { className: "num right", children: money(t.totalTradeValue) }),
            /* @__PURE__ */ jsx("td", { className: "small", children: t.holes.map((h) => h.key).join(", ") || "—" }),
            /* @__PURE__ */ jsx("td", { className: "small", children: t.positionalSurplus.filter((s) => OFFENSE_POSITIONS.includes(s.position) && (s.level === "high" || s.level === "very high")).map((s) => s.position).join(", ") || "—" }),
            onPickTeam ? /* @__PURE__ */ jsx("td", { children: !t.isUser ? /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: pickable ? "primary pick-btn" : "pick-btn",
                onClick: (e) => {
                  e.stopPropagation();
                  onPickTeam(t.teamId);
                },
                children: pickable ? "This is my team" : "This is me"
              }
            ) : null }) : null
          ]
        },
        t.teamId
      )) })
    ] }) })
  ] });
}
function describeFreeRanks(ranks) {
  if (!ranks.length) return "the trade summaries";
  if (ranks.length === 1) return `your #${ranks[0]} trade in full`;
  return `trades ${ranks.map((r) => `#${r}`).join(", ")} in full`;
}
function LicensePanel({
  license,
  config,
  entitled,
  busy,
  onActivate,
  onRemove,
  onUpgrade
}) {
  const [key, setKey] = useState("");
  if (config.provider === "none") return null;
  return /* @__PURE__ */ jsxs("section", { className: "panel license", children: [
    /* @__PURE__ */ jsxs("div", { className: "panel-head", children: [
      /* @__PURE__ */ jsx("h2", { children: config.productName }),
      /* @__PURE__ */ jsx("span", { className: `tag ${entitled ? "tag-ok" : ""}`, children: entitled ? "Pro active" : "Free tier" })
    ] }),
    entitled ? /* @__PURE__ */ jsxs("div", { className: "license-row", children: [
      /* @__PURE__ */ jsxs("span", { className: "muted small", children: [
        "Licensed",
        license.email ? ` to ${license.email}` : "",
        license.expiresAt ? ` · renews/expires ${new Date(license.expiresAt).toLocaleDateString()}` : " · lifetime",
        license.message ? ` · ${license.message}` : ""
      ] }),
      /* @__PURE__ */ jsx("button", { className: "text-btn small", onClick: onRemove, children: "Remove key" })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("p", { className: "small", children: [
        "Free: full team analysis, league overview and ",
        describeFreeRanks(config.freeRanks),
        ". Pro: every ranked trade with lineups, explanations and rank reasons."
      ] }),
      config.singleCheckout ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "plans", children: config.plans.map((plan) => /* @__PURE__ */ jsxs("div", { className: "plan plan-info", children: [
          /* @__PURE__ */ jsx("span", { className: "plan-label", children: plan.label }),
          plan.priceLabel ? /* @__PURE__ */ jsx("span", { className: "plan-price", children: plan.priceLabel }) : null,
          /* @__PURE__ */ jsx("span", { className: "plan-desc muted small", children: plan.description })
        ] }, plan.id)) }),
        /* @__PURE__ */ jsxs("div", { className: "license-row", children: [
          /* @__PURE__ */ jsxs("button", { type: "button", className: "primary", onClick: () => onUpgrade(), children: [
            "Unlock all trades",
            config.priceLabel ? ` · ${config.priceLabel}` : ""
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "muted small", children: [
            "Choose your pass at checkout.",
            config.provider === "signed" ? " Your license key is emailed to you after payment." : ""
          ] })
        ] })
      ] }) : config.plans.length ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "plans", children: config.plans.map((plan) => {
          var _a;
          return /* @__PURE__ */ jsxs("button", { type: "button", className: `plan${((_a = config.defaultPlan) == null ? void 0 : _a.id) === plan.id ? " plan-default" : ""}`, onClick: () => onUpgrade(plan), children: [
            /* @__PURE__ */ jsx("span", { className: "plan-label", children: plan.label }),
            plan.priceLabel ? /* @__PURE__ */ jsx("span", { className: "plan-price", children: plan.priceLabel }) : null,
            /* @__PURE__ */ jsx("span", { className: "plan-desc muted small", children: plan.description })
          ] }, plan.id);
        }) }),
        config.provider === "signed" ? /* @__PURE__ */ jsx("p", { className: "muted small", children: "Pick a pass to pay. Your license key is emailed to you after payment." }) : null
      ] }) : /* @__PURE__ */ jsxs("div", { className: "license-row", children: [
        /* @__PURE__ */ jsx("button", { className: "primary", disabled: true, children: "Upgrade" }),
        /* @__PURE__ */ jsx("span", { className: "muted small", children: "Checkout not configured (VITE_PAYWALL_CHECKOUT, or VITE_PAYWALL_STORE and VITE_PAYWALL_VARIANT_*)." })
      ] }),
      /* @__PURE__ */ jsxs(
        "form",
        {
          className: "license-row",
          onSubmit: (e) => {
            e.preventDefault();
            onActivate(key);
          },
          children: [
            /* @__PURE__ */ jsx("input", { value: key, onChange: (e) => setKey(e.target.value), placeholder: "Already bought? Paste your license key", autoComplete: "off" }),
            /* @__PURE__ */ jsx("button", { type: "submit", className: "primary", disabled: busy || !key.trim(), children: busy ? "Checking…" : "Activate" })
          ]
        }
      ),
      license.message && license.status !== "active" ? /* @__PURE__ */ jsx("div", { className: "note error small", children: license.message }) : null
    ] })
  ] });
}
function UnfairTradeCard({ trade, analysis }) {
  const [open, setOpen] = useState(false);
  const [showLineups, setShowLineups] = useState(false);
  const sim = trade.simulation;
  const opp = analysis.teams.find((t) => t.teamId === sim.candidate.partnerTeamId);
  const user = analysis.user;
  const incomingIds = new Set(sim.candidate.userReceives.map((p) => p.id));
  const outgoingIds = new Set(sim.candidate.userSends.map((p) => p.id));
  const pushback = trade.acceptance.accepted ? `Their angle: ${trade.opponentAngle}. It also passes the normal rules, so it may well go through.` : `Their angle: ${trade.opponentAngle}. Expect some pushback: ${trade.acceptance.rejections.join("; ")}.`;
  return /* @__PURE__ */ jsxs("article", { className: "panel trade unfair", children: [
    /* @__PURE__ */ jsxs("header", { className: "trade-head", onClick: () => setOpen((v) => !v), children: [
      /* @__PURE__ */ jsxs("div", { className: "trade-rank", children: [
        "#",
        trade.rank
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "trade-summary", children: [
        /* @__PURE__ */ jsxs("div", { className: "trade-title", children: [
          "Trade with ",
          /* @__PURE__ */ jsx("b", { children: opp.teamName }),
          /* @__PURE__ */ jsx("span", { className: "tag tier tier-unfair", children: "Unfair" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "trade-gains", children: [
          /* @__PURE__ */ jsxs("span", { className: "gain you", children: [
            "You ",
            signed1(sim.user.projectionGain),
            " pts"
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "gain value", children: [
            "+",
            money(trade.valueGain),
            " value"
          ] }),
          /* @__PURE__ */ jsxs("span", { className: `gain ${sim.opponent.projectionGain >= 0 ? "them" : "neg"}`, children: [
            "They ",
            signed1(sim.opponent.projectionGain)
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "muted", children: [
            money(sim.user.tradeValueSent),
            " ↔ ",
            money(sim.user.tradeValueReceived)
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx(ExpandToggle, { open })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "trade-sides", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "side-label", children: "You send" }),
        /* @__PURE__ */ jsx("ul", { children: sim.candidate.userSends.map((p) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(PlayerChip, { player: p, marginal: user.playerMarginalValues[p.id] ?? 0 }) }, p.id)) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "side-label", children: "You receive" }),
        /* @__PURE__ */ jsx("ul", { children: sim.candidate.userReceives.map((p) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(PlayerChip, { player: p, marginal: opp.playerMarginalValues[p.id] ?? 0 }) }, p.id)) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(TradeScreenLink, { league: analysis.originalLeague, trade: sim.candidate, partnerName: opp.teamName }),
    open ? /* @__PURE__ */ jsxs("div", { className: "trade-detail", children: [
      /* @__PURE__ */ jsxs("div", { className: "metrics", children: [
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Your lineup" }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            fmt1(sim.user.projectionBefore),
            " → ",
            fmt1(sim.user.projectionAfter)
          ] }),
          /* @__PURE__ */ jsx("div", { className: "num gain pos", children: signed1(sim.user.projectionGain) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Your trade value" }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            money(user.totalTradeValue),
            " → ",
            money(user.totalTradeValue + trade.valueGain)
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "num gain pos", children: [
            "+",
            money(trade.valueGain)
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: opp.teamName }),
          /* @__PURE__ */ jsxs("div", { className: "num", children: [
            fmt1(sim.opponent.projectionBefore),
            " → ",
            fmt1(sim.opponent.projectionAfter)
          ] }),
          /* @__PURE__ */ jsxs("div", { className: `num gain ${sim.opponent.projectionGain >= 0 ? "pos" : "neg"}`, children: [
            signed1(sim.opponent.projectionGain),
            " · ",
            money(sim.opponent.tradeValueGain),
            " value"
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "metric", children: [
          /* @__PURE__ */ jsx("div", { className: "metric-label", children: "Rank score" }),
          /* @__PURE__ */ jsx("div", { className: "num", children: trade.score.toFixed(2) }),
          /* @__PURE__ */ jsxs("div", { className: "muted small", children: [
            "pts + $ ÷ ",
            analysis.config.unfairValuePointsPerProjectionPoint
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx("h4", { children: "Why it helps you" }),
      /* @__PURE__ */ jsx("ul", { children: trade.explanation.userSide.map((l, i) => /* @__PURE__ */ jsx("li", { children: l }, i)) }),
      /* @__PURE__ */ jsx("h4", { children: "Their side" }),
      /* @__PURE__ */ jsx("ul", { children: trade.explanation.opponentSide.map((l, i) => /* @__PURE__ */ jsx("li", { children: l }, i)) }),
      /* @__PURE__ */ jsx("p", { className: "muted small", children: pushback }),
      /* @__PURE__ */ jsxs("button", { className: "text-btn", onClick: () => setShowLineups((v) => !v), children: [
        showLineups ? "Hide" : "Show",
        " before/after lineups"
      ] }),
      showLineups ? /* @__PURE__ */ jsxs("div", { className: "lineups-grid", children: [
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.user.before, title: "You · before", highlight: outgoingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.user.after, title: "You · after", highlight: incomingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.opponent.before, title: `${opp.teamName} · before`, highlight: incomingIds }),
        /* @__PURE__ */ jsx(LineupTable, { lineup: sim.opponent.after, title: `${opp.teamName} · after`, highlight: outgoingIds })
      ] }) : null
    ] }) : null
  ] });
}
function describeScoring(s) {
  const rec = s.receptionPoints >= 0.75 ? "Full PPR" : s.receptionPoints >= 0.25 ? "Half PPR" : "Standard";
  return s.passTdPoints === 4 ? rec : `${rec} · ${s.passTdPoints}pt pass TD`;
}
const THIN_PROPS_COVERAGE = 0.5;
function TradeReport(props) {
  const { result, league, report, datasetLabels, warnings, onPickTeam, license, paywall, entitled, licenseBusy, onActivate, onRemoveLicense, onUpgrade, only } = props;
  const show = (block) => !only || only === block || block === "meta" && false;
  const analysis = result.analysis;
  const user = analysis.user;
  const [list, setList] = useState("fair");
  const fairAll = result.allTrades ?? result.trades;
  const unfairAll = result.allUnfairTrades ?? result.unfairTrades;
  const [pages, setPages] = useState({ fair: 1, unfair: 1 });
  useEffect(() => setPages({ fair: 1, unfair: 1 }), [result]);
  const pageCount = Math.max(1, list === "fair" ? result.tradePageCount ?? 1 : result.unfairPageCount ?? 1);
  const page = Math.min(pages[list], pageCount);
  const tradesRef = useRef(null);
  const goToPage = (next) => {
    var _a;
    setPages((p) => ({ ...p, [list]: Math.max(1, Math.min(pageCount, next)) }));
    (_a = tradesRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const fairPage = fairAll.filter((t) => (t.page ?? 1) === page);
  const unfairPage = unfairAll.filter((t) => (t.page ?? 1) === page);
  const shown = list === "fair" ? fairPage : unfairPage;
  const total = list === "fair" ? fairAll.length : unfairAll.length;
  const pager = pageCount > 1 ? /* @__PURE__ */ jsxs("nav", { className: "pager", "aria-label": "Trade pages", children: [
    /* @__PURE__ */ jsx("button", { type: "button", className: "pager-btn", disabled: page <= 1, onClick: () => goToPage(page - 1), children: "‹ Previous" }),
    /* @__PURE__ */ jsxs("span", { className: "pager-status", children: [
      "Page ",
      /* @__PURE__ */ jsx("b", { children: page }),
      " of ",
      pageCount,
      shown.length ? /* @__PURE__ */ jsxs("span", { className: "muted", children: [
        " · #",
        shown[0].rank,
        "–#",
        shown[shown.length - 1].rank,
        " of ",
        total
      ] }) : null
    ] }),
    /* @__PURE__ */ jsx("button", { type: "button", className: "pager-btn", disabled: page >= pageCount, onClick: () => goToPage(page + 1), children: "Next ›" })
  ] }) : null;
  const licenseRef = useRef(null);
  const leagueRef = useRef(null);
  const [flash, setFlash] = useState(false);
  const showPlans = () => {
    if (!licenseRef.current) return onUpgrade();
    licenseRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    setFlash(true);
  };
  const offense = league.teams.flatMap((t) => t.players).filter((p) => OFFENSE_POSITIONS.includes(p.position));
  const withProps = offense.filter((p) => p.projectionSource === "dataset").length;
  const coverage = offense.length ? withProps / offense.length : 1;
  const thinProps = coverage < THIN_PROPS_COVERAGE;
  const userOffense = user ? user.roster.filter((p) => OFFENSE_POSITIONS.includes(p.position)) : [];
  const userWithProps = userOffense.filter((p) => p.projectionSource === "dataset").length;
  const staleNames = offense.filter((p) => p.projectionStale).map((p) => p.name);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    show("meta") ? /* @__PURE__ */ jsxs("div", { className: "chips", children: [
      /* @__PURE__ */ jsx("span", { className: "chip", children: league.settings.platform }),
      /* @__PURE__ */ jsx("span", { className: "chip", children: league.settings.leagueName }),
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        league.settings.season,
        " · week ",
        league.settings.week
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "chip", children: [
        league.settings.teamCount,
        " teams"
      ] }),
      /* @__PURE__ */ jsx("span", { className: "chip", children: describeScoring(league.settings.scoring) }),
      /* @__PURE__ */ jsx("span", { className: "chip", children: league.settings.lineupSlots.map((s) => s.count > 1 ? `${s.count}${s.label}` : s.label).join(" ") }),
      /* @__PURE__ */ jsxs("span", { className: "chip muted", children: [
        result.stats.simulated,
        " trades simulated in ",
        result.stats.elapsedMs,
        " ms"
      ] })
    ] }) : null,
    show("meta") ? /* @__PURE__ */ jsxs("div", { className: "muted small datasets", children: [
      "Projections: ",
      datasetLabels.projections,
      ". Trade values: ",
      datasetLabels.tradeValues,
      ".",
      report ? ` Matched ${report.projectionMatched}/${report.rosteredPlayers} rostered players to projections, ${report.tradeValueMatched} to trade values (${report.tradeValueEstimated} estimated).` : ""
    ] }) : null,
    show("meta") ? warnings.map((w, i) => /* @__PURE__ */ jsx("div", { className: "note warn", children: w }, i)) : null,
    !user && show("meta") ? /* @__PURE__ */ jsxs("div", { className: "pick-callout", role: "status", children: [
      /* @__PURE__ */ jsx("div", { className: "pick-callout-step", children: "Step 1" }),
      /* @__PURE__ */ jsxs("div", { className: "pick-callout-body", children: [
        /* @__PURE__ */ jsx("h2", { className: "pick-callout-title", children: "Which team is yours?" }),
        /* @__PURE__ */ jsx("p", { children: "Pick it in the league table below. Your trades and team analysis appear as soon as we know which roster is yours. You only do this once per league." })
      ] }),
      /* @__PURE__ */ jsx("button", { type: "button", className: "primary pick-callout-btn", onClick: () => {
        var _a;
        return (_a = leagueRef.current) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "start" });
      }, children: "Pick my team ↓" })
    ] }) : null,
    user && show("trades") ? /* @__PURE__ */ jsxs("section", { id: "trades", ref: tradesRef, children: [
      /* @__PURE__ */ jsx("div", { className: "section-head", children: /* @__PURE__ */ jsx("h2", { children: "Suggested trades" }) }),
      /* @__PURE__ */ jsxs("div", { className: "list-tabs", role: "tablist", "aria-label": "Trade type", children: [
        /* @__PURE__ */ jsxs("button", { type: "button", role: "tab", "aria-selected": list === "fair", className: `list-tab${list === "fair" ? " active" : ""}`, onClick: () => setList("fair"), children: [
          /* @__PURE__ */ jsxs("span", { className: "list-tab-label", children: [
            "Fair trades (",
            fairAll.length,
            ")"
          ] }),
          /* @__PURE__ */ jsx("span", { className: "list-tab-sub", children: "Both managers have a reason to say yes" })
        ] }),
        /* @__PURE__ */ jsxs("button", { type: "button", role: "tab", "aria-selected": list === "unfair", className: `list-tab${list === "unfair" ? " active" : ""}`, onClick: () => setList("unfair"), children: [
          /* @__PURE__ */ jsxs("span", { className: "list-tab-label", children: [
            "Unfair trades (",
            unfairAll.length,
            ")"
          ] }),
          /* @__PURE__ */ jsx("span", { className: "list-tab-sub", children: "Lopsided in your favor" })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "muted small list-note", children: list === "fair" ? `Realistic for both managers: ${result.stats.candidates} candidates after pruning, ${result.stats.accepted} acceptable.` : `Lopsided in your favor but still takeable: you send only players worth more than $${analysis.config.unfairMinOutgoingValue}, you never get back a player worth more than the best one you send or within ${analysis.config.unfairMinValueGapPercent}% of any player you send, the deal raises both your total trade value and this week's lineup, they get at most ${analysis.config.unfairMaxValueGainPercent}% less value, lose at most ${analysis.config.unfairMaxOpponentLoss} points, and have an angle to say yes. ${result.unfairStats.plausible} of ${result.unfairStats.qualifying} value grabs made the cut.` }),
      thinProps ? /* @__PURE__ */ jsxs("div", { className: "note warn", children: [
        /* @__PURE__ */ jsx("b", { children: "Limited suggestions this week so far." }),
        " Props are posted for only ",
        withProps,
        " of ",
        offense.length,
        " rostered QB/RB/WR/TE (",
        Math.round(coverage * 100),
        "%)",
        user ? `, including ${userWithProps} of ${userOffense.length} on your team` : "",
        ". Players without a line are never offered or requested, so fewer trades qualify",
        fairAll.length < 5 ? ` (${fairAll.length} shown)` : "",
        ". Lines usually fill in by Wednesday or Thursday; re-run then for the full list."
      ] }) : null,
      staleNames.length ? /* @__PURE__ */ jsxs("div", { className: "note", children: [
        /* @__PURE__ */ jsx("b", { children: "Left out of trades:" }),
        " ",
        staleNames.slice(0, 8).join(", "),
        staleNames.length > 8 ? ` and ${staleNames.length - 8} more` : "",
        ". The latest odds no longer post every prop needed for ",
        staleNames.length === 1 ? "this player's" : "these players'",
        " projection, so ",
        staleNames.length === 1 ? "it relies" : "they rely",
        " on older lines."
      ] }) : null,
      pager,
      list === "fair" ? fairAll.length === 0 ? /* @__PURE__ */ jsxs("div", { className: "note", children: [
        "No trade cleared the bar (gain ≥ ",
        analysis.config.minUserGain,
        " pts for you, within the value tolerance, and rational for the other manager). Loosen the tolerances in Settings or check the dataset match warnings."
      ] }) : fairPage.map(
        (t) => entitled || paywall.freeRanks.includes(t.rank) ? /* @__PURE__ */ jsx(TradeCard, { trade: t, analysis }, t.rank) : /* @__PURE__ */ jsx(LockedTradeCard, { trade: t, analysis, onUpgrade: showPlans, priceLabel: paywall.priceLabel }, t.rank)
      ) : unfairAll.length === 0 ? /* @__PURE__ */ jsxs("div", { className: "note", children: [
        "No unfair trade qualified: nothing that sends only players worth more than $",
        analysis.config.unfairMinOutgoingValue,
        " raises both your total trade value and this week's lineup."
      ] }) : unfairPage.map(
        (t) => entitled || paywall.freeRanks.includes(t.rank) ? /* @__PURE__ */ jsx(UnfairTradeCard, { trade: t, analysis }, t.rank) : /* @__PURE__ */ jsx(LockedTradeCard, { trade: { rank: t.rank, simulation: t.simulation, valueGain: t.valueGain }, analysis, onUpgrade: showPlans, priceLabel: paywall.priceLabel }, t.rank)
      ),
      pager
    ] }) : null,
    user && show("analysis") ? /* @__PURE__ */ jsx("div", { id: "analysis", children: /* @__PURE__ */ jsx(TeamAnalysisPanel, { analysis, team: user }) }) : null,
    show("league") ? /* @__PURE__ */ jsx("div", { id: "league", ref: leagueRef, children: /* @__PURE__ */ jsx(LeagueTable, { analysis, onPickTeam, picking: !user }) }) : null,
    show("license") ? /* @__PURE__ */ jsx("div", { id: "license", ref: licenseRef, className: flash ? "license-flash" : void 0, onAnimationEnd: () => setFlash(false), children: /* @__PURE__ */ jsx(LicensePanel, { license, config: paywall, entitled, busy: licenseBusy, onActivate, onRemove: onRemoveLicense, onUpgrade }) }) : null
  ] });
}
function SettingsPanel({ settings, onChange }) {
  var _a, _b;
  const [open, setOpen] = useState(false);
  const cfg = settings.config;
  const set = (patch) => onChange({ ...settings, ...patch });
  const setCfg = (patch) => onChange({ ...settings, config: { ...cfg, ...patch } });
  return /* @__PURE__ */ jsxs("section", { className: "panel", children: [
    /* @__PURE__ */ jsxs("div", { className: "panel-head clickable", onClick: () => setOpen((v) => !v), children: [
      /* @__PURE__ */ jsx("h2", { children: "Settings" }),
      /* @__PURE__ */ jsx("span", { className: "caret", children: open ? "▾" : "▸" })
    ] }),
    open ? /* @__PURE__ */ jsxs("div", { className: "settings", children: [
      /* @__PURE__ */ jsxs("div", { className: "field-row", children: [
        /* @__PURE__ */ jsxs("label", { children: [
          "Trade value",
          /* @__PURE__ */ jsxs("select", { value: String(cfg.enforceValueTolerance ?? DEFAULT_CONFIG.enforceValueTolerance), onChange: (e) => setCfg({ enforceValueTolerance: e.target.value === "true" }), children: [
            /* @__PURE__ */ jsx("option", { value: "true", children: "require fair values (gap limit below)" }),
            /* @__PURE__ */ jsx("option", { value: "false", children: "scores fairness only" })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Max trade value gap (%)",
          /* @__PURE__ */ jsx("input", { type: "number", min: 0, max: 60, value: cfg.maxTradeValueDifferencePercent ?? DEFAULT_CONFIG.maxTradeValueDifferencePercent, onChange: (e) => setCfg({ maxTradeValueDifferencePercent: Number(e.target.value) }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Min gain for you (pts)",
          /* @__PURE__ */ jsx("input", { type: "number", step: 0.5, min: 0, value: cfg.minUserGain ?? DEFAULT_CONFIG.minUserGain, onChange: (e) => setCfg({ minUserGain: Number(e.target.value) }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Max opponent loss (pts)",
          /* @__PURE__ */ jsx("input", { type: "number", step: 0.5, min: 0, value: cfg.maxOpponentLoss ?? DEFAULT_CONFIG.maxOpponentLoss, onChange: (e) => setCfg({ maxOpponentLoss: Number(e.target.value) }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Trades to show",
          /* @__PURE__ */ jsx("input", { type: "number", min: 1, max: 20, value: cfg.topN ?? DEFAULT_CONFIG.topN, onChange: (e) => setCfg({ topN: Number(e.target.value) }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Max per partner",
          /* @__PURE__ */ jsx("input", { type: "number", min: 1, max: 20, value: cfg.maxTradesPerPartner ?? DEFAULT_CONFIG.maxTradesPerPartner, onChange: (e) => setCfg({ maxTradesPerPartner: Number(e.target.value) }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Ranking",
          /* @__PURE__ */ jsxs("select", { value: cfg.rankingMode ?? DEFAULT_CONFIG.rankingMode, onChange: (e) => setCfg({ rankingMode: e.target.value }), children: [
            /* @__PURE__ */ jsx("option", { value: "winWin", children: "win/win first, then your gain" }),
            /* @__PURE__ */ jsx("option", { value: "userGain", children: "your lineup gain only" })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Unlisted trade value",
          /* @__PURE__ */ jsxs("select", { value: cfg.unlistedTradeValue ?? DEFAULT_CONFIG.unlistedTradeValue, onChange: (e) => setCfg({ unlistedTradeValue: e.target.value }), children: [
            /* @__PURE__ */ jsx("option", { value: "estimate", children: "estimate from projection" }),
            /* @__PURE__ */ jsx("option", { value: "zero", children: "treat as $0" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "field-row", children: [
        /* @__PURE__ */ jsxs("label", { children: [
          "Scoring override: receptions",
          /* @__PURE__ */ jsxs(
            "select",
            {
              value: ((_a = settings.scoringOverride) == null ? void 0 : _a.receptionPoints) ?? "",
              onChange: (e) => {
                var _a2;
                return set({ scoringOverride: e.target.value === "" ? ((_a2 = settings.scoringOverride) == null ? void 0 : _a2.passTdPoints) != null ? { passTdPoints: settings.scoringOverride.passTdPoints } : null : { ...settings.scoringOverride ?? {}, receptionPoints: Number(e.target.value) } });
              },
              children: [
                /* @__PURE__ */ jsx("option", { value: "", children: "use league setting" }),
                /* @__PURE__ */ jsx("option", { value: "0", children: "Standard (0)" }),
                /* @__PURE__ */ jsx("option", { value: "0.5", children: "Half PPR (0.5)" }),
                /* @__PURE__ */ jsx("option", { value: "1", children: "Full PPR (1)" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Scoring override: pass TD",
          /* @__PURE__ */ jsxs(
            "select",
            {
              value: ((_b = settings.scoringOverride) == null ? void 0 : _b.passTdPoints) ?? "",
              onChange: (e) => {
                var _a2;
                return set({ scoringOverride: e.target.value === "" ? ((_a2 = settings.scoringOverride) == null ? void 0 : _a2.receptionPoints) != null ? { receptionPoints: settings.scoringOverride.receptionPoints } : null : { ...settings.scoringOverride ?? {}, passTdPoints: Number(e.target.value) } });
              },
              children: [
                /* @__PURE__ */ jsx("option", { value: "", children: "use league setting" }),
                /* @__PURE__ */ jsx("option", { value: "4", children: "4" }),
                /* @__PURE__ */ jsx("option", { value: "6", children: "6" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs("details", { children: [
        /* @__PURE__ */ jsx("summary", { children: "Custom datasets (optional)" }),
        /* @__PURE__ */ jsxs("p", { className: "muted small", children: [
          "Leave empty to use VegasLytics weekly medians and the published trade values. Otherwise supply JSON arrays of",
          " ",
          /* @__PURE__ */ jsx("code", { children: "{ name, position, medianProjection }" }),
          " and ",
          /* @__PURE__ */ jsx("code", { children: "{ name, position, tradeValue }" }),
          " (a combined list with both fields works for either)."
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Projection JSON URL",
          /* @__PURE__ */ jsx("input", { type: "url", value: settings.projectionUrl, onChange: (e) => set({ projectionUrl: e.target.value }), placeholder: "https://…/projections.json" })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Trade value JSON URL",
          /* @__PURE__ */ jsx("input", { type: "url", value: settings.tradeValueUrl, onChange: (e) => set({ tradeValueUrl: e.target.value }), placeholder: "https://…/trade-values.json" })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Paste projection JSON",
          /* @__PURE__ */ jsx("textarea", { rows: 3, value: settings.projectionJson, onChange: (e) => set({ projectionJson: e.target.value }) })
        ] }),
        /* @__PURE__ */ jsxs("label", { children: [
          "Paste trade value JSON",
          /* @__PURE__ */ jsx("textarea", { rows: 3, value: settings.tradeValueJson, onChange: (e) => set({ tradeValueJson: e.target.value }) })
        ] })
      ] })
    ] }) : null
  ] });
}
export {
  AlwaysValidValidator,
  BettingProsProjectionSource,
  DEFAULT_CONFIG,
  DEFAULT_SETTINGS,
  EMPTY_LICENSE,
  LeagueTable,
  LemonSqueezyValidator,
  LicensePanel,
  LockedTradeCard,
  PAYWALL_CONFIG,
  PlayerIndex,
  PublishedTradeValueSource,
  RemoteValidator,
  SettingsPanel,
  SignedKeyValidator,
  StaticProjectionSource,
  StaticTradeValueSource,
  TIER_LABEL,
  TIER_RANK,
  TRADE_VALUES_BASE,
  TeamAnalysisPanel,
  TradeCard,
  TradeReport,
  UrlProjectionSource,
  UrlTradeValueSource,
  activateLicense,
  analyzeLeague,
  analyzeSurplus,
  analyzeWeaknesses,
  applyFreeWaiverMoves,
  applyResult,
  bruteForceOptimalTotal,
  buildInsight,
  classifyTier,
  compareRanked,
  compareReason,
  computeMarginalValues,
  computeReplacementLevels,
  computeSlotBenchmarks,
  depthScoreFor,
  dropCandidates,
  enrichLeague,
  espnSeasonFromDate,
  espnTeamForSwid,
  estimateProjectionFromValue,
  estimateTradeValue,
  evaluateAcceptance,
  explainTrade,
  findUnfairTrades,
  fitRosterToSize,
  generateCandidates,
  initialsCompatible,
  instanceName,
  isEntitled,
  leagueSizeKeyFor,
  lineupEntryGain,
  loadLicense,
  loadSettings,
  makeLeague,
  makePlayer,
  marginalLineupValue,
  mergeConfig,
  needsRevalidation,
  normalizeDstName,
  normalizeEspnLeague,
  normalizeEspnPlayerPool,
  normalizeName,
  normalizeSleeperLeague,
  opponentAngle,
  optimalTotal,
  optimizeLineup,
  paginateByPartner,
  parsePosition,
  parseProjectionJson,
  parseTradeValueJson,
  positionalNeed,
  positionsIn,
  publishedTradeValueUrl,
  rankPartners,
  refreshLicense,
  replacementForSlot,
  runTradeOptimizer,
  saveLicense,
  saveSettings,
  scoreTrade,
  scoringKeyFor,
  scoringModeFor,
  secondaryBand,
  simulateTrade,
  solvedWeaknessKeys,
  solverFor,
  surplusLevel,
  syntheticLeague,
  tradeable,
  trimSleeperPlayers,
  validatorFor,
  valueWithinTolerance
};
